var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPocketStudioPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pocket_studio_plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pocket_studio_plus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(23.499600, 51.499900)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 261.217,
    y1: 95.6753,
    x2: 315.737,
    y2: 74.9873,
    id: "Stroke-1",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.6613,
    y1: 52.6279,
    x2: 372.8643,
    y2: 53.3099,
    id: "Stroke-2",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.0656,
    y1: 74.104,
    x2: 372.5856,
    y2: 53.416,
    id: "Stroke-3",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.4319,
    y1: 113.0488,
    x2: 258.8629,
    y2: 96.5688,
    id: "Stroke-4",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.449,
    y1: 78.582,
    x2: 213.356,
    y2: 113.836,
    id: "Stroke-5",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.3557,
    y1: 113.8364,
    x2: 213.3557,
    y2: 314.7574,
    id: "Stroke-6",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.8147,
    y1: 74.1616,
    x2: 316.0177,
    y2: 74.8436,
    id: "Stroke-7",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.8479,
    y1: 336.5537,
    x2: 257.8479,
    y2: 409.7697,
    id: "Stroke-8",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.9406,
    y1: 52.5219,
    x2: 418.3706,
    y2: 36.0419,
    id: "Stroke-10",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.9377,
    y1: 95.7812,
    x2: 259.1407,
    y2: 96.4632,
    id: "Stroke-11",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.1526,
    y1: 113.1548,
    x2: 213.3556,
    y2: 113.8368,
    id: "Stroke-12",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.8215,
    y1: 334.2128,
    x2: 257.8215,
    y2: 336.5638,
    id: "Stroke-13",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.8215,
    y1: 334.2128,
    x2: 257.8215,
    y2: 331.8618,
    id: "Stroke-14",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.4465,
    y1: 35.2544,
    x2: 418.6495,
    y2: 35.9364,
    id: "Stroke-15",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.9021,193.6103 L162.5451,190.3733 C162.1891,190.3733 161.9011,190.6613 161.9011,191.0173 L161.9011,199.3743 C161.9011,199.7303 162.1891,200.0183 162.5451,200.0183 L170.9021,203.2553 C171.2571,203.2553 171.5461,202.9663 171.5461,202.6113 L171.5461,194.2543 C171.5461,193.8983 171.2571,193.6103 170.9021,193.6103 Z",
    id: "Stroke-16",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.9153,
    y1: 331.5937,
    x2: 257.9153,
    y2: 329.2427,
    id: "Stroke-18",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.9153,
    y1: 326.8925,
    x2: 213.4223,
    y2: 310.0095,
    id: "Stroke-20",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.9153,
    y1: 326.8925,
    x2: 257.9153,
    y2: 329.2435,
    id: "Stroke-22",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 465.5901,
    y1: 248.0888,
    x2: 257.9151,
    y2: 326.8928,
    id: "Stroke-24",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.696,
    y1: 273.7695,
    x2: 120.449,
    y2: 318.0725,
    id: "Stroke-26",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.696,
    y1: 276.1201,
    x2: 3.696,
    y2: 306.2331,
    id: "Stroke-28",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.696,
    y1: 276.1201,
    x2: 3.696,
    y2: 273.7691,
    id: "Stroke-30",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.6613,
    y1: 238.0644,
    x2: 417.7823,
    y2: 221.7024,
    id: "Stroke-32",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5569,
    y1: 219.0371,
    x2: 374.6609,
    y2: 235.6931,
    id: "Stroke-34",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5569,
    y1: 221.3876,
    x2: 374.6609,
    y2: 238.0446,
    id: "Stroke-36",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.9377,
    y1: 291.9794,
    x2: 260.9377,
    y2: 95.7814,
    id: "Stroke-38",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.1408,
    y1: 292.6611,
    x2: 259.1408,
    y2: 96.4631,
    id: "Stroke-40",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.8645,
    y1: 147.6211,
    x2: 372.8645,
    y2: 236.4461,
    id: "Stroke-42",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.8645,
    y1: 53.31,
    x2: 372.8645,
    y2: 145.27,
    id: "Stroke-44",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.6613,
    y1: 52.6279,
    x2: 374.6613,
    y2: 248.8269,
    id: "Stroke-46",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5569,
    y1: 130.2124,
    x2: 374.6609,
    y2: 146.8684,
    id: "Stroke-48",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.0481,
    y1: 279.5634,
    x2: 215.1531,
    y2: 296.2204,
    id: "Stroke-50",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.8645,
    y1: 145.2705,
    x2: 317.8145,
    y2: 166.1595,
    id: "Stroke-52",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.8645,
    y1: 147.6211,
    x2: 260.9395,
    y2: 190.0921,
    id: "Stroke-54",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5569,
    y1: 96.7256,
    x2: 374.6609,
    y2: 113.3816,
    id: "Stroke-56",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.8137,
    y1: 270.3974,
    x2: 317.8137,
    y2: 259.6864,
    id: "Stroke-58",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.0168,
    y1: 271.08,
    x2: 316.0168,
    y2: 260.368,
    id: "Stroke-60",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.7854,
    y1: 114.1176,
    x2: 317.8144,
    y2: 134.9766,
    id: "Stroke-62",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.1526,
    y1: 309.3535,
    x2: 215.1526,
    y2: 113.1545,
    id: "Stroke-64",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.925,
    y1: 135.6938,
    x2: 260.938,
    y2: 156.5588,
    id: "Stroke-66",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.0481,
    y1: 235.7177,
    x2: 215.1531,
    y2: 252.3737,
    id: "Stroke-68",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.8645,
    y1: 238.7968,
    x2: 260.9395,
    y2: 281.2678,
    id: "Stroke-70",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5569,
    y1: 172.8403,
    x2: 374.6609,
    y2: 189.4973,
    id: "Stroke-72",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5569,
    y1: 175.1914,
    x2: 374.6609,
    y2: 191.8474,
    id: "Stroke-74",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.8147,
    y1: 166.1596,
    x2: 317.8147,
    y2: 74.1616,
    id: "Stroke-76",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.0178,
    y1: 166.8413,
    x2: 316.0178,
    y2: 74.8433,
    id: "Stroke-78",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.0481,
    y1: 157.2519,
    x2: 215.1531,
    y2: 173.9089,
    id: "Stroke-80",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.0481,
    y1: 188.3881,
    x2: 215.1531,
    y2: 205.0451,
    id: "Stroke-82",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.0481,
    y1: 190.7387,
    x2: 215.1531,
    y2: 207.3957,
    id: "Stroke-84",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.1526,
    y1: 298.5908,
    x2: 258.2736,
    y2: 282.2288,
    id: "Stroke-86",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.0178,
    y1: 166.8413,
    x2: 260.9398,
    y2: 187.7413,
    id: "Stroke-88",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.8645,
    y1: 238.7968,
    x2: 372.8645,
    y2: 249.5088,
    id: "Stroke-90",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.0481,
    y1: 233.3671,
    x2: 215.1531,
    y2: 250.0231,
    id: "Stroke-92",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.8645,
    y1: 236.4462,
    x2: 260.9395,
    y2: 278.9172,
    id: "Stroke-94",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5569,
    y1: 127.8613,
    x2: 374.6609,
    y2: 144.5183,
    id: "Stroke-96",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.8645,
    y1: 147.6211,
    x2: 372.8645,
    y2: 145.2701,
    id: "Stroke-98",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.8645,
    y1: 238.7968,
    x2: 372.8645,
    y2: 236.4458,
    id: "Stroke-100",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.6496,
    y1: 232.1347,
    x2: 418.6496,
    y2: 35.9357,
    id: "Stroke-102",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.0178,
    y1: 166.8413,
    x2: 317.8148,
    y2: 166.1593,
    id: "Stroke-104",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.4226,
    y1: 310.0097,
    x2: 421.0976,
    y2: 231.2057,
    id: "Stroke-106",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.4226,
    y1: 314.7109,
    x2: 215.4936,
    y2: 315.4969,
    id: "Stroke-108",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.4934,
    y1: 315.497,
    x2: 255.8474,
    y2: 330.809,
    id: "Stroke-110",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.7326,330.9482 C256.5846,330.9482 256.4306,330.9382 256.2836,330.9172 C256.2096,330.9062 256.1346,330.8912 256.0616,330.8742 C255.9896,330.8562 255.9166,330.8352 255.8466,330.8082",
    id: "Stroke-112",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.7326,
    y1: 331.1455,
    x2: 257.9156,
    y2: 331.5935,
    id: "Stroke-114",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.9153,
    y1: 331.5937,
    x2: 465.5903,
    y2: 252.7897,
    id: "Stroke-116",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.1379,
    y1: 336.0644,
    x2: 464.2069,
    y2: 258.2494,
    id: "Stroke-118",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.3562,
    y1: 314.9697,
    x2: 119.8912,
    y2: 279.5037,
    id: "Stroke-120",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.8909,
    y1: 284.205,
    x2: 213.3299,
    y2: 319.661,
    id: "Stroke-122",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.3298,
    y1: 319.6806,
    x2: 257.8218,
    y2: 336.5636,
    id: "Stroke-124",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.8215,
    y1: 336.5634,
    x2: 259.0785,
    y2: 336.0864,
    id: "Stroke-126",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.6164,
    y1: 233.0585,
    x2: 132.0414,
    y2: 232.5175,
    id: "Stroke-128",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.3738,
    y1: 230.7597,
    x2: 129.9498,
    y2: 231.3007,
    id: "Stroke-130",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6233,233.2558 C130.6233,233.1288 130.6143,232.9978 130.5963,232.8668 C130.5783,232.7278 130.5493,232.5868 130.5113,232.4478 C130.4723,232.3028 130.4223,232.1588 130.3643,232.0208 C130.3043,231.8778 130.2353,231.7398 130.1583,231.6098 C130.0813,231.4798 129.9963,231.3568 129.9043,231.2428 C129.8733,231.2058 129.8433,231.1688 129.8113,231.1348 C129.7493,231.0658 129.6843,231.0008 129.6183,230.9418 C129.5243,230.8568 129.4263,230.7818 129.3263,230.7198 C129.2913,230.6968 129.2553,230.6768 129.2193,230.6568 C129.1553,230.6228 129.0903,230.5928 129.0243,230.5678 C128.9593,230.5428 128.8933,230.5238 128.8283,230.5088 C128.7943,230.5018 128.7603,230.4948 128.7273,230.4908 C128.6923,230.4858 128.6583,230.4838 128.6243,230.4818 C128.5903,230.4798 128.5563,230.4798 128.5213,230.4808 C128.4873,230.4828 128.4533,230.4848 128.4193,230.4888 C128.3853,230.4938 128.3513,230.5008 128.3173,230.5088 C128.2763,230.5198 128.2363,230.5318 128.1963,230.5468",
    id: "Stroke-132",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.7824,
    y1: 231.0781,
    x2: 374.6614,
    y2: 247.4401,
    id: "Stroke-134",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.2405,
    y1: 258.2373,
    x2: 465.4965,
    y2: 257.7593,
    id: "Stroke-136",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.7365,
    y1: 74.9873,
    x2: 315.7365,
    y2: 133.1333,
    id: "Stroke-138",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.7365,
    y1: 133.1328,
    x2: 261.2165,
    y2: 153.8208,
    id: "Stroke-140",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.217,
    y1: 153.8208,
    x2: 261.217,
    y2: 95.6748,
    id: "Stroke-142",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.9406,
    y1: 74.3051,
    x2: 259.4196,
    y2: 94.9931,
    id: "Stroke-144",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.9377,
    y1: 95.7812,
    x2: 258.8507,
    y2: 94.9562,
    id: "Stroke-146",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.1408,
    y1: 96.4629,
    x2: 258.9028,
    y2: 96.3399,
    id: "Stroke-148",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.1531,
    y1: 249.3388,
    x2: 223.1531,
    y2: 265.9428,
    id: "Stroke-150",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 370.8059,
    y1: 52.5156,
    x2: 372.8649,
    y2: 53.3096,
    id: "Stroke-152",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.8762,
    y1: 131.6142,
    x2: 336.8762,
    y2: 127.7432,
    id: "Stroke-154",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.8762,
    y1: 222.79,
    x2: 336.8762,
    y2: 161.277,
    id: "Stroke-156",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.5686,
    y1: 51.8466,
    x2: 374.6616,
    y2: 52.6276,
    id: "Stroke-158",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.8762,
    y1: 131.5722,
    x2: 317.8142,
    y2: 138.8052,
    id: "Stroke-160",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.5852,
    y1: 53.416,
    x2: 372.5852,
    y2: 111.562,
    id: "Stroke-162",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.5852,
    y1: 111.5615,
    x2: 318.0652,
    y2: 132.2495,
    id: "Stroke-164",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.0656,
    y1: 132.2495,
    x2: 318.0656,
    y2: 74.1035,
    id: "Stroke-166",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.5852,
    y1: 53.416,
    x2: 370.7892,
    y2: 52.734,
    id: "Stroke-168",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 370.7893,
    y1: 52.7343,
    x2: 316.2683,
    y2: 73.4223,
    id: "Stroke-170",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.0481,
    y1: 281.914,
    x2: 215.1531,
    y2: 298.571,
    id: "Stroke-172",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.8205,
    y1: 131.5932,
    x2: 372.8645,
    y2: 145.2702,
    id: "Stroke-174",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.136,
    y1: 270.0273,
    x2: 260.938,
    y2: 290.5933,
    id: "Stroke-176",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.2405,
    y1: 258.0253,
    x2: 464.2075,
    y2: 258.0383,
    id: "Stroke-178",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.4148,
    y1: 259.5439,
    x2: 201.8398,
    y2: 259.0029,
    id: "Stroke-180",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.4221,259.7412 C200.4221,259.6142 200.4131,259.4842 200.3961,259.3522 C200.3771,259.2132 200.3481,259.0722 200.3111,258.9332 C200.2711,258.7882 200.2221,258.6452 200.1631,258.5062 C200.1041,258.3632 200.0341,258.2252 199.9571,258.0952 C199.8801,257.9652 199.7951,257.8422 199.7031,257.7282 C199.6721,257.6912 199.6421,257.6552 199.6101,257.6202 C199.5481,257.5512 199.4841,257.4862 199.4171,257.4272 C199.3231,257.3422 199.2251,257.2672 199.1251,257.2052 C199.0901,257.1832 199.0541,257.1622 199.0191,257.1422 C198.9541,257.1082 198.8891,257.0782 198.8231,257.0532 C198.7571,257.0292 198.6921,257.0092 198.6271,256.9952 C198.5931,256.9872 198.5591,256.9802 198.5261,256.9762 C198.4911,256.9712 198.4571,256.9692 198.4231,256.9672 C198.3891,256.9652 198.3541,256.9652 198.3201,256.9662 C198.2861,256.9682 198.2521,256.9702 198.2181,256.9752 C198.1831,256.9802 198.1501,256.9862 198.1161,256.9952 C198.0751,257.0052 198.0351,257.0172 197.9951,257.0322",
    id: "Stroke-182",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 284.7199,
    y1: 154.9648,
    x2: 282.8589,
    y2: 154.2588,
    id: "Stroke-184",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.4226,
    y1: 314.7109,
    x2: 215.4936,
    y2: 315.4969,
    id: "Stroke-186",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.8625,
    y1: 96.5688,
    x2: 258.8625,
    y2: 154.7138,
    id: "Stroke-188",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.8625,
    y1: 154.7143,
    x2: 215.4315,
    y2: 171.1943,
    id: "Stroke-190",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.4319,
    y1: 171.1943,
    x2: 215.4319,
    y2: 113.0493,
    id: "Stroke-192",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.8625,
    y1: 96.5688,
    x2: 257.0655,
    y2: 95.8868,
    id: "Stroke-194",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.0656,
    y1: 95.8872,
    x2: 213.6346,
    y2: 112.3672,
    id: "Stroke-196",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.7854,
    y1: 111.7666,
    x2: 317.8144,
    y2: 132.6256,
    id: "Stroke-198",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.3449,
    y1: 259.3359,
    x2: 461.3449,
    y2: 332.5509,
    id: "Stroke-200",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.4416,
    y1: 408.4052,
    x2: 261.4416,
    y2: 335.1902,
    id: "Stroke-202",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.0119,
    y1: 248.4453,
    x2: 317.8139,
    y2: 269.0103,
    id: "Stroke-204",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.925,
    y1: 135.6938,
    x2: 315.925,
    y2: 133.3428,
    id: "Stroke-206",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.925,
    y1: 133.3432,
    x2: 260.938,
    y2: 154.2082,
    id: "Stroke-208",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.4934,
    y1: 315.497,
    x2: 255.8474,
    y2: 330.809,
    id: "Stroke-210",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.3298,
    y1: 317.33,
    x2: 213.3298,
    y2: 319.681,
    id: "Stroke-212",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.0256,
    y1: 95.6201,
    x2: 258.9026,
    y2: 96.3121,
    id: "Stroke-214",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.7424,
    y1: 0.6455,
    x2: 415.8574,
    y2: 34.8405,
    id: "Stroke-216",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.1526,
    y1: 113.1548,
    x2: 122.2456,
    y2: 77.8638,
    id: "Stroke-218",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.8576,
    y1: 35.6323,
    x2: 415.8576,
    y2: 34.8403,
    id: "Stroke-220",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.7375,
    y1: 73.4111,
    x2: 313.9405,
    y2: 74.0931,
    id: "Stroke-222",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.8147,
    y1: 74.1616,
    x2: 315.7377,
    y2: 73.4116,
    id: "Stroke-224",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.0295,
    y1: 149.3144,
    x2: 280.0295,
    y2: 153.1854,
    id: "Stroke-226",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.3298,
    y1: 314.9794,
    x2: 213.7308,
    y2: 314.8284,
    id: "Stroke-228",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.3298,
    y1: 314.9794,
    x2: 213.3298,
    y2: 317.3304,
    id: "Stroke-230",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.8826,
    y1: 241.8867,
    x2: 155.3076,
    y2: 241.3467,
    id: "Stroke-232",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.6399,
    y1: 239.5878,
    x2: 153.2149,
    y2: 240.1288,
    id: "Stroke-234",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.8894,242.0849 C153.8894,241.9569 153.8804,241.8269 153.8634,241.6949 C153.8444,241.5559 153.8154,241.4159 153.7784,241.2759 C153.7384,241.1309 153.6894,240.9879 153.6314,240.8489 C153.5714,240.7059 153.5024,240.5689 153.4244,240.4389 C153.3474,240.3079 153.2624,240.1859 153.1704,240.0709 C153.1394,240.0339 153.1094,239.9979 153.0774,239.9629 C153.0154,239.8939 152.9514,239.8289 152.8844,239.7699 C152.7904,239.6859 152.6924,239.6109 152.5924,239.5479 C152.5574,239.5259 152.5214,239.5059 152.4864,239.4859 C152.4214,239.4509 152.3564,239.4209 152.2904,239.3969 C152.2254,239.3719 152.1594,239.3519 152.0944,239.3379 C152.0604,239.3299 152.0264,239.3239 151.9934,239.3189 C151.9594,239.3139 151.9254,239.3119 151.8904,239.3099 C151.8564,239.3079 151.8224,239.3079 151.7874,239.3099 C151.7534,239.3109 151.7194,239.3139 151.6854,239.3179 C151.6504,239.3229 151.6174,239.3299 151.5834,239.3379 C151.5424,239.3479 151.5024,239.3599 151.4634,239.3749",
    id: "Stroke-236",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.0481,
    y1: 154.9013,
    x2: 215.1531,
    y2: 171.5583,
    id: "Stroke-238",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.2737,
    y1: 291.6044,
    x2: 215.1527,
    y2: 307.9664,
    id: "Stroke-240",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.6487,
    y1: 165.5625,
    x2: 310.7877,
    y2: 164.8555,
    id: "Stroke-242",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.3703,
    y1: 94.1875,
    x2: 374.9403,
    y2: 110.6675,
    id: "Stroke-244",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.9406,
    y1: 110.6674,
    x2: 374.9406,
    y2: 52.5214,
    id: "Stroke-246",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.5744,
    y1: 35.3603,
    x2: 373.1434,
    y2: 51.8403,
    id: "Stroke-248",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.1492,
    y1: 250.7158,
    x2: 178.5732,
    y2: 250.1748,
    id: "Stroke-250",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.9065,
    y1: 248.4169,
    x2: 176.4815,
    y2: 248.9569,
    id: "Stroke-252",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.156,250.913 C177.156,250.786 177.147,250.655 177.129,250.524 C177.111,250.385 177.082,250.244 177.044,250.104 C177.005,249.96 176.955,249.816 176.897,249.678 C176.837,249.535 176.768,249.397 176.691,249.267 C176.614,249.137 176.529,249.014 176.436,248.9 C176.406,248.863 176.375,248.826 176.344,248.792 C176.282,248.723 176.217,248.657 176.151,248.598 C176.056,248.514 175.959,248.439 175.859,248.377 C175.824,248.354 175.788,248.334 175.752,248.314 C175.688,248.279 175.623,248.25 175.557,248.225 C175.492,248.2 175.426,248.181 175.361,248.166 C175.327,248.158 175.293,248.152 175.26,248.148 C175.225,248.143 175.191,248.14 175.157,248.139 C175.123,248.137 175.088,248.137 175.054,248.138 C175.02,248.14 174.986,248.142 174.952,248.146 C174.917,248.151 174.884,248.158 174.85,248.166 C174.809,248.176 174.768,248.188 174.729,248.203",
    id: "Stroke-254",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.6613,
    y1: 188.812,
    x2: 382.6613,
    y2: 205.416,
    id: "Stroke-256",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.1531,
    y1: 170.8725,
    x2: 223.1531,
    y2: 174.7675,
    id: "Stroke-258",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.1531,
    y1: 204.3593,
    x2: 223.1531,
    y2: 219.7473,
    id: "Stroke-260",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.0295,
    y1: 153.143,
    x2: 260.9375,
    y2: 160.387,
    id: "Stroke-262",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.8147,
    y1: 132.1543,
    x2: 318.0657,
    y2: 132.2493,
    id: "Stroke-264",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.218,
    y1: 94.2456,
    x2: 418.557,
    y2: 94.3746,
    id: "Stroke-266",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.1526,
    y1: 177.8032,
    x2: 223.1526,
    y2: 174.7672,
    id: "Stroke-268",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 465.1897,
    y1: 252.9423,
    x2: 465.4967,
    y2: 253.0583,
    id: "Stroke-270",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.6613,
    y1: 162.2558,
    x2: 382.6613,
    y2: 159.2198,
    id: "Stroke-272",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.7326,330.9482 C256.5846,330.9482 256.4306,330.9382 256.2836,330.9172 C256.2096,330.9062 256.1346,330.8912 256.0616,330.8742 C255.9896,330.8562 255.9166,330.8352 255.8466,330.8082",
    id: "Stroke-274",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.7092,
    y1: 154.7724,
    x2: 259.0482,
    y2: 154.9014,
    id: "Stroke-276",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.2483,
    y1: 282.2187,
    x2: 258.2733,
    y2: 282.2287,
    id: "Stroke-278",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.6613,
    y1: 110.5615,
    x2: 374.9403,
    y2: 110.6675,
    id: "Stroke-280",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.6613,
    y1: 143.8325,
    x2: 382.6613,
    y2: 159.2195,
    id: "Stroke-282",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.6613,
    y1: 110.3462,
    x2: 382.6613,
    y2: 114.2412,
    id: "Stroke-284",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.2688,
    y1: 73.4223,
    x2: 316.2688,
    y2: 73.5753,
    id: "Stroke-286",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.6613,
    y1: 117.2768,
    x2: 382.6613,
    y2: 114.2408,
    id: "Stroke-288",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.1531,
    y1: 265.9433,
    x2: 259.0481,
    y2: 279.5633,
    id: "Stroke-290",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.1726,
    y1: 257.2451,
    x2: 199.7476,
    y2: 257.7861,
    id: "Stroke-292",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5569,
    y1: 94.3745,
    x2: 374.6609,
    y2: 111.0315,
    id: "Stroke-294",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.3703,
    y1: 231.5156,
    x2: 418.3703,
    y2: 232.2416,
    id: "Stroke-296",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.449,
    y1: 228.121,
    x2: 120.449,
    y2: 228.121,
    id: "Stroke-298",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.7405,
    y1: 270.4833,
    x2: 315.7355,
    y2: 271.1863,
    id: "Stroke-300",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.1531,
    y1: 219.747,
    x2: 259.0481,
    y2: 233.367,
    id: "Stroke-302",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.5539,
    y1: 133.2021,
    x2: 315.9249,
    y2: 133.3431,
    id: "Stroke-304",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.9377,
    y1: 251.6054,
    x2: 336.8757,
    y2: 222.7904,
    id: "Stroke-306",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.6613,
    y1: 208.4531,
    x2: 382.6613,
    y2: 205.4161,
    id: "Stroke-308",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.6613,
    y1: 205.4165,
    x2: 418.5573,
    y2: 219.0375,
    id: "Stroke-310",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.7561,
    y1: 221.6914,
    x2: 417.7821,
    y2: 221.7024,
    id: "Stroke-312",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.7917,232.6123 C131.8377,232.6393 131.8847,232.6623 131.9327,232.6793 C131.9587,232.6903 131.9857,232.6993 132.0127,232.7063 C132.0307,232.7113 132.0497,232.7153 132.0677,232.7173 C132.0777,232.7193 132.0857,232.7203 132.0957,232.7223 C132.1137,232.7253 132.1317,232.7263 132.1497,232.7273 C132.1597,232.7283 132.1707,232.7283 132.1817,232.7283 C132.2097,232.7283 132.2387,232.7273 132.2667,232.7223 C132.3097,232.7163 132.3507,232.7063 132.3907,232.6913",
    id: "Stroke-314",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.3909,232.6914 C132.4239,232.6784 132.4549,232.6644 132.4849,232.6444 C132.5189,232.6244 132.5509,232.6004 132.5809,232.5724 C132.6029,232.5514 132.6249,232.5294 132.6439,232.5044 C132.6559,232.4904 132.6669,232.4754 132.6779,232.4614 C132.6849,232.4494 132.6919,232.4384 132.6989,232.4274 C132.7319,232.3744 132.7599,232.3144 132.7819,232.2504 C132.8019,232.1924 132.8169,232.1294 132.8269,232.0654 C132.8379,231.9984 132.8429,231.9274 132.8429,231.8554",
    id: "Stroke-316",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.2571,232.1826 C127.2571,232.3026 127.2661,232.4266 127.2821,232.5516 C127.3001,232.6846 127.3271,232.8176 127.3631,232.9496 C127.4011,233.0876 127.4471,233.2236 127.5031,233.3566 C127.5601,233.4916 127.6261,233.6216 127.6991,233.7456 C127.7481,233.8286 127.8001,233.9086 127.8561,233.9836 C127.9071,234.0546 127.9611,234.1206 128.0171,234.1846 C128.0791,234.2546 128.1451,234.3216 128.2121,234.3806 C128.3011,234.4616 128.3941,234.5326 128.4891,234.5916 C128.5841,234.6506 128.6791,234.6996 128.7761,234.7356 C128.8221,234.7536 128.8691,234.7686 128.9161,234.7806 C128.9471,234.7886 128.9791,234.7956 129.0111,234.8016 C129.0231,234.8036 129.0361,234.8056 129.0481,234.8076",
    id: "Stroke-318",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.0481,234.8076 C129.1201,234.8186 129.1911,234.8286 129.2631,234.8386",
    id: "Stroke-320",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.2629,234.8388 C129.2669,234.8398 129.2709,234.8408 129.2749,234.8408 C129.3089,234.8458 129.3439,234.8488 129.3769,234.8508 C129.4109,234.8528 129.4459,234.8528 129.4799,234.8508 C129.5149,234.8498 129.5489,234.8468 129.5829,234.8418 C129.6589,234.8308 129.7339,234.8128 129.8049,234.7848",
    id: "Stroke-322",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.8049,234.7851 C129.8309,234.7751 129.8559,234.7641 129.8809,234.7531 C129.9119,234.7371 129.9439,234.7211 129.9739,234.7021 C130.0349,234.6651 130.0929,234.6211 130.1459,234.5711 C130.1809,234.5391 130.2149,234.5041 130.2459,234.4671 C130.2869,234.4181 130.3249,234.3651 130.3599,234.3081 C130.3799,234.2761 130.3989,234.2421 130.4169,234.2071 C130.4519,234.1381 130.4839,234.0631 130.5109,233.9851 C130.5239,233.9471 130.5349,233.9081 130.5459,233.8681 C130.5669,233.7911 130.5839,233.7101 130.5969,233.6271 C130.6019,233.5861 130.6079,233.5451 130.6119,233.5031 C130.6189,233.4231 130.6229,233.3401 130.6229,233.2561",
    id: "Stroke-324",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.3738,230.7597 C131.4068,230.7467 131.4398,230.7387 131.4748,230.7357 C131.5118,230.7317 131.5478,230.7327 131.5848,230.7377 C131.6198,230.7417 131.6528,230.7497 131.6858,230.7607 C131.7208,230.7727 131.7548,230.7877 131.7868,230.8057 C131.8178,230.8217 131.8478,230.8407 131.8758,230.8617 C131.9058,230.8827 131.9348,230.9057 131.9608,230.9307 C131.9868,230.9537 132.0118,230.9797 132.0348,231.0057 L132.0528,231.0267 C132.0588,231.0317 132.0638,231.0397 132.0698,231.0467 C132.0818,231.0617 132.0928,231.0747 132.1028,231.0907 C132.1238,231.1187 132.1448,231.1477 132.1628,231.1777 C132.1818,231.2087 132.1998,231.2397 132.2168,231.2727 C132.2488,231.3357 132.2778,231.4027 132.2998,231.4697 C132.3228,231.5377 132.3408,231.6077 132.3528,231.6777 C132.3598,231.7137 132.3648,231.7497 132.3678,231.7867 C132.3708,231.8217 132.3728,231.8567 132.3728,231.8917",
    id: "Stroke-326",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.1965,230.5468 C128.1715,230.5568 128.1455,230.5678 128.1205,230.5788 C128.0895,230.5938 128.0585,230.6108 128.0275,230.6288 C127.9665,230.6668 127.9085,230.7098 127.8555,230.7598 C127.8205,230.7928 127.7875,230.8268 127.7555,230.8648 C127.7555,230.8648 127.7555,230.8648 127.7555,230.8658",
    id: "Stroke-328",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7551,230.8662 C127.7081,230.9212 127.6621,230.9762 127.6151,231.0322",
    id: "Stroke-330",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.615,231.0322 C127.611,231.0372 127.607,231.0432 127.602,231.0482 C127.582,231.0722 127.563,231.0972 127.545,231.1242 C127.532,231.1422 127.52,231.1622 127.508,231.1812 C127.45,231.2742 127.403,231.3772 127.365,231.4892 C127.33,231.5912 127.303,231.6992 127.285,231.8132 C127.267,231.9312 127.257,232.0542 127.257,232.1822",
    id: "Stroke-332",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5203,230.3974 C131.4883,230.4104 131.4563,230.4254 131.4263,230.4444 C131.3923,230.4644 131.3603,230.4894 131.3303,230.5174 C131.3083,230.5384 131.2873,230.5604 131.2673,230.5844 C131.2553,230.5984 131.2443,230.6134 131.2343,230.6284 C131.2273,230.6394 131.2193,230.6504 131.2123,230.6624 C131.1793,230.7154 131.1513,230.7744 131.1303,230.8384 C131.1283,230.8434 131.1263,230.8484 131.1243,230.8544",
    id: "Stroke-334",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8425,231.8554 C132.8425,231.7874 132.8375,231.7164 132.8285,231.6464 C132.8185,231.5714 132.8025,231.4964 132.7825,231.4214 C132.7615,231.3434 132.7355,231.2664 132.7035,231.1924 C132.6715,231.1154 132.6345,231.0424 132.5925,230.9714 C132.5655,230.9244 132.5355,230.8794 132.5045,230.8364 C132.4755,230.7964 132.4455,230.7594 132.4125,230.7234 C132.3775,230.6834 132.3405,230.6454 132.3015,230.6124 C132.2515,230.5664 132.1985,230.5254 132.1445,230.4924 C132.0905,230.4584 132.0355,230.4304 131.9795,230.4094 C131.9525,230.3984 131.9255,230.3904 131.8985,230.3834 C131.8805,230.3784 131.8625,230.3744 131.8435,230.3714 C131.8345,230.3694 131.8245,230.3684 131.8155,230.3674 C131.7975,230.3644 131.7795,230.3624 131.7615,230.3614 C131.7515,230.3614 131.7405,230.3604 131.7305,230.3604 C131.7015,230.3604 131.6725,230.3624 131.6445,230.3664 C131.6015,230.3724 131.5605,230.3824 131.5205,230.3974",
    id: "Stroke-336",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.3723,231.8916 C132.3723,231.9536 132.3673,232.0166 132.3553,232.0786 C132.3443,232.1396 132.3263,232.2016 132.3003,232.2576 C132.2743,232.3156 132.2403,232.3686 132.1963,232.4136 C132.1523,232.4586 132.1003,232.4956 132.0413,232.5176",
    id: "Stroke-338",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.7824,
    y1: 221.7021,
    x2: 417.7824,
    y2: 231.0781,
    id: "Stroke-340",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5569,
    y1: 221.3876,
    x2: 418.5569,
    y2: 219.0366,
    id: "Stroke-342",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.9377,
    y1: 153.7143,
    x2: 261.2167,
    y2: 153.8203,
    id: "Stroke-344",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.4201,
    y1: 94.9936,
    x2: 259.4201,
    y2: 95.2056,
    id: "Stroke-346",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.7365,
    y1: 74.9873,
    x2: 313.9405,
    y2: 74.3053,
    id: "Stroke-348",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.4201,
    y1: 94.9936,
    x2: 261.2171,
    y2: 95.6756,
    id: "Stroke-350",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.8508,
    y1: 94.9565,
    x2: 257.0898,
    y2: 95.6245,
    id: "Stroke-352",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.5686,
    y1: 51.8466,
    x2: 370.8056,
    y2: 52.5156,
    id: "Stroke-354",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.2688,
    y1: 73.4223,
    x2: 318.0658,
    y2: 74.1043,
    id: "Stroke-356",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.6613,
    y1: 114.2407,
    x2: 418.5573,
    y2: 127.8617,
    id: "Stroke-358",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5569,
    y1: 130.2124,
    x2: 418.5569,
    y2: 127.8614,
    id: "Stroke-360",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.9397,
    y1: 187.7412,
    x2: 260.9377,
    y2: 187.7412,
    id: "Stroke-362",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.9397,
    y1: 278.9169,
    x2: 260.9377,
    y2: 278.9159,
    id: "Stroke-364",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.9397,
    y1: 281.2675,
    x2: 260.9377,
    y2: 281.2665,
    id: "Stroke-366",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.1526,
    y1: 268.9794,
    x2: 223.1526,
    y2: 265.9434,
    id: "Stroke-368",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.136,
    y1: 260.7021,
    x2: 315.136,
    y2: 270.0271,
    id: "Stroke-370",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1096,155.7792 C238.0636,155.7612 238.0166,155.7472 237.9676,155.7372 C237.9186,155.7262 237.8676,155.7192 237.8166,155.7162 C237.7626,155.7132 237.7096,155.7132 237.6556,155.7172 C237.5986,155.7222 237.5436,155.7312 237.4876,155.7432 C237.4396,155.7542 237.3916,155.7672 237.3446,155.7832 C237.2966,155.8002 237.2486,155.8192 237.2006,155.8412 C237.1516,155.8632 237.1036,155.8872 237.0566,155.9142 C237.0086,155.9422 236.9616,155.9722 236.9156,156.0042 C236.8306,156.0632 236.7496,156.1292 236.6726,156.1992 C236.5936,156.2722 236.5196,156.3492 236.4506,156.4312 C236.3826,156.5112 236.3186,156.5952 236.2586,156.6822 C236.2446,156.7032 236.2296,156.7252 236.2156,156.7472 C236.2016,156.7692 236.1876,156.7912 236.1736,156.8142 C236.1456,156.8592 236.1186,156.9052 236.0926,156.9522 C236.0436,157.0432 235.9976,157.1362 235.9556,157.2312 C235.9126,157.3292 235.8746,157.4302 235.8396,157.5312 C235.7736,157.7312 235.7246,157.9382 235.6966,158.1472 C235.6816,158.2552 235.6726,158.3622 235.6706,158.4702 C235.6686,158.5732 235.6716,158.6762 235.6796,158.7792 C235.6846,158.8362 235.6916,158.8922 235.7006,158.9472 C235.7096,159.0012 235.7196,159.0542 235.7326,159.1072 C235.7446,159.1572 235.7576,159.2062 235.7746,159.2562 C235.7896,159.3012 235.8056,159.3472 235.8246,159.3922",
    id: "Stroke-372",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.4797,160.0771 C236.5257,160.0941 236.5727,160.1081 236.6217,160.1191 C236.6707,160.1301 236.7217,160.1361 236.7727,160.1401 C236.8267,160.1431 236.8797,160.1421 236.9337,160.1381 C236.9907,160.1341 237.0457,160.1251 237.1017,160.1131 C237.1497,160.1021 237.1977,160.0881 237.2447,160.0731 C237.2927,160.0561 237.3407,160.0371 237.3887,160.0151 C237.4377,159.9931 237.4857,159.9681 237.5327,159.9411 C237.5807,159.9131 237.6277,159.8841 237.6737,159.8511 C237.7587,159.7921 237.8397,159.7271 237.9167,159.6571 C237.9957,159.5841 238.0697,159.5061 238.1387,159.4251 C238.2077,159.3451 238.2707,159.2611 238.3307,159.1741 C238.3447,159.1521 238.3597,159.1301 238.3737,159.1081 C238.3877,159.0871 238.4017,159.0641 238.4157,159.0421 C238.4437,158.9961 238.4697,158.9501 238.4967,158.9031 C238.5457,158.8121 238.5917,158.7201 238.6337,158.6251 C238.6767,158.5261 238.7147,158.4261 238.7497,158.3251 C238.8157,158.1241 238.8647,157.9171 238.8927,157.7081 C238.9077,157.6011 238.9167,157.4931 238.9187,157.3851 C238.9207,157.2821 238.9177,157.1791 238.9097,157.0771 C238.9047,157.0201 238.8977,156.9641 238.8877,156.9081 C238.8797,156.8541 238.8697,156.8011 238.8567,156.7491 C238.8447,156.6991 238.8317,156.6491 238.8147,156.6001 C238.7997,156.5541 238.7837,156.5091 238.7647,156.4641",
    id: "Stroke-374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.8127,156.08 C236.8247,156.145 236.8337,156.21 236.8397,156.276 C236.8457,156.345 236.8497,156.414 236.8507,156.484 C236.8517,156.551 236.8507,156.618 236.8467,156.684 C236.8427,156.753 236.8367,156.822 236.8287,156.89 C236.8117,157.024 236.7867,157.158 236.7537,157.289 C236.7207,157.42 236.6797,157.55 236.6317,157.677 C236.5837,157.804 236.5287,157.928 236.4657,158.048 C236.4347,158.108 236.4007,158.169 236.3657,158.227 C236.3487,158.256 236.3307,158.285 236.3127,158.312 C236.2937,158.34 236.2767,158.368 236.2567,158.395 C236.1807,158.507 236.0957,158.614 236.0047,158.714 C235.9147,158.814 235.8147,158.908 235.7087,158.991",
    id: "Stroke-376",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7649,156.4643 C238.7339,156.3893 238.6969,156.3163 238.6549,156.2473 C238.6119,156.1783 238.5629,156.1123 238.5079,156.0533 C238.4529,155.9923 238.3919,155.9393 238.3249,155.8923 C238.2579,155.8463 238.1859,155.8083 238.1099,155.7793",
    id: "Stroke-378",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.8245,159.392 C235.8555,159.467 235.8925,159.539 235.9345,159.609 C235.9775,159.678 236.0265,159.744 236.0815,159.803 C236.1365,159.863 236.1975,159.917 236.2645,159.963 C236.3315,160.01 236.4035,160.048 236.4795,160.077",
    id: "Stroke-380",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.3625,136.0981 C289.3165,136.0811 289.2685,136.0671 289.2205,136.0561 C289.1715,136.0451 289.1205,136.0391 289.0685,136.0361 C289.0145,136.0321 288.9615,136.0331 288.9075,136.0371 C288.8515,136.0411 288.7955,136.0501 288.7405,136.0621 C288.6915,136.0731 288.6435,136.0871 288.5965,136.1021 C288.5485,136.1191 288.5005,136.1391 288.4535,136.1601 C288.4045,136.1821 288.3555,136.2071 288.3095,136.2341 C288.2605,136.2621 288.2135,136.2921 288.1685,136.3241 C288.0825,136.3831 288.0015,136.4491 287.9255,136.5181 C287.8465,136.5911 287.7725,136.6691 287.7035,136.7501 C287.6345,136.8311 287.5705,136.9151 287.5115,137.0021 C287.4965,137.0231 287.4825,137.0451 287.4675,137.0671 C287.4535,137.0891 287.4395,137.1111 287.4255,137.1331 C287.3975,137.1791 287.3715,137.2251 287.3445,137.2721 C287.2955,137.3631 287.2495,137.4551 287.2085,137.5511 C287.1655,137.6491 287.1265,137.7491 287.0915,137.8501 C287.0255,138.0511 286.9765,138.2581 286.9485,138.4671 C286.9345,138.5741 286.9245,138.6821 286.9235,138.7901 C286.9205,138.8931 286.9235,138.9961 286.9315,139.0981 C286.9365,139.1551 286.9435,139.2111 286.9535,139.2671 C286.9615,139.3211 286.9715,139.3741 286.9845,139.4271 C286.9965,139.4761 287.0105,139.5261 287.0265,139.5751 C287.0415,139.6211 287.0575,139.6661 287.0765,139.7111",
    id: "Stroke-382",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.7317,140.3964 C287.7777,140.4134 287.8247,140.4274 287.8737,140.4384 C287.9227,140.4494 287.9737,140.4554 288.0247,140.4594 C288.0787,140.4624 288.1317,140.4614 288.1857,140.4574 C288.2427,140.4534 288.2987,140.4444 288.3537,140.4324 C288.4027,140.4214 288.4497,140.4074 288.4967,140.3924 C288.5457,140.3754 288.5937,140.3564 288.6407,140.3344 C288.6897,140.3124 288.7377,140.2874 288.7847,140.2604 C288.8337,140.2324 288.8797,140.2034 288.9257,140.1704 C289.0107,140.1114 289.0917,140.0464 289.1687,139.9764 C289.2477,139.9034 289.3217,139.8254 289.3907,139.7444 C289.4597,139.6644 289.5237,139.5804 289.5827,139.4934 C289.5967,139.4714 289.6117,139.4494 289.6267,139.4274 C289.6397,139.4064 289.6547,139.3834 289.6687,139.3614 C289.6967,139.3154 289.7227,139.2694 289.7487,139.2224 C289.7977,139.1314 289.8437,139.0394 289.8857,138.9434 C289.9287,138.8454 289.9677,138.7454 290.0017,138.6444 C290.0687,138.4434 290.1167,138.2364 290.1447,138.0274 C290.1597,137.9204 290.1687,137.8124 290.1707,137.7044 C290.1737,137.6014 290.1707,137.4984 290.1617,137.3964 C290.1567,137.3394 290.1497,137.2834 290.1407,137.2274 C290.1317,137.1734 290.1217,137.1204 290.1087,137.0684 C290.0967,137.0184 290.0837,136.9684 290.0677,136.9194 C290.0527,136.8734 290.0367,136.8284 290.0177,136.7834",
    id: "Stroke-384",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.0647,136.3994 C288.0777,136.4644 288.0857,136.5294 288.0917,136.5954 C288.0987,136.6644 288.1027,136.7334 288.1037,136.8034 C288.1047,136.8704 288.1027,136.9374 288.0987,137.0034 C288.0957,137.0724 288.0887,137.1414 288.0817,137.2094 C288.0647,137.3434 288.0397,137.4774 288.0057,137.6084 C287.9727,137.7394 287.9317,137.8694 287.8837,137.9964 C287.8357,138.1224 287.7807,138.2474 287.7187,138.3674 C287.6867,138.4274 287.6537,138.4874 287.6177,138.5464 C287.6007,138.5754 287.5837,138.6044 287.5647,138.6314 C287.5467,138.6594 287.5287,138.6874 287.5097,138.7144 C287.4327,138.8264 287.3487,138.9334 287.2567,139.0334 C287.1667,139.1334 287.0667,139.2274 286.9607,139.3104",
    id: "Stroke-386",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.0178,136.7837 C289.9858,136.7087 289.9498,136.6357 289.9068,136.5667 C289.8638,136.4977 289.8148,136.4317 289.7598,136.3727 C289.7058,136.3117 289.6438,136.2587 289.5778,136.2117 C289.5098,136.1657 289.4388,136.1277 289.3628,136.0977",
    id: "Stroke-388",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.0764,139.7114 C287.1074,139.7864 287.1444,139.8584 287.1864,139.9284 C287.2294,139.9974 287.2784,140.0634 287.3344,140.1224 C287.3884,140.1824 287.4494,140.2364 287.5164,140.2824 C287.5834,140.3294 287.6554,140.3674 287.7314,140.3964",
    id: "Stroke-390",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.1086,114.6079 C346.0626,114.5899 346.0156,114.5759 345.9666,114.5659 C345.9176,114.5549 345.8666,114.5479 345.8146,114.5449 C345.7616,114.5419 345.7076,114.5419 345.6546,114.5469 C345.5976,114.5509 345.5416,114.5599 345.4866,114.5719 C345.4376,114.5829 345.3906,114.5959 345.3436,114.6119 C345.2946,114.6289 345.2466,114.6479 345.1996,114.6699 C345.1506,114.6919 345.1026,114.7159 345.0556,114.7429 C345.0066,114.7709 344.9606,114.8009 344.9146,114.8329 C344.8296,114.8919 344.7486,114.9579 344.6716,115.0279 C344.5926,115.1009 344.5186,115.1779 344.4496,115.2599 C344.3806,115.3399 344.3166,115.4239 344.2576,115.5109 C344.2426,115.5329 344.2286,115.5539 344.2136,115.5759 C344.2006,115.5979 344.1856,115.6199 344.1716,115.6429 C344.1436,115.6879 344.1176,115.7339 344.0916,115.7809 C344.0426,115.8719 343.9956,115.9649 343.9546,116.0599 C343.9116,116.1579 343.8726,116.2589 343.8386,116.3599 C343.7716,116.5599 343.7226,116.7679 343.6956,116.9769 C343.6806,117.0839 343.6716,117.1919 343.6696,117.2989 C343.6666,117.4019 343.6696,117.5049 343.6786,117.6079 C343.6826,117.6649 343.6906,117.7209 343.6996,117.7759 C343.7086,117.8299 343.7186,117.8829 343.7316,117.9359 C343.7436,117.9859 343.7566,118.0349 343.7726,118.0849 C343.7876,118.1299 343.8036,118.1759 343.8226,118.2209",
    id: "Stroke-392",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.4778,118.9057 C344.5238,118.9227 344.5718,118.9367 344.6198,118.9477 C344.6688,118.9587 344.7198,118.9647 344.7718,118.9687 C344.8258,118.9717 344.8788,118.9707 344.9328,118.9677 C344.9898,118.9627 345.0448,118.9537 345.0998,118.9417 C345.1488,118.9307 345.1968,118.9167 345.2438,118.9017 C345.2918,118.8847 345.3398,118.8657 345.3868,118.8437 C345.4358,118.8217 345.4838,118.7967 345.5308,118.7697 C345.5798,118.7417 345.6268,118.7127 345.6718,118.6797 C345.7578,118.6207 345.8378,118.5557 345.9148,118.4857 C345.9938,118.4127 346.0688,118.3347 346.1378,118.2537 C346.2058,118.1737 346.2698,118.0897 346.3288,118.0027 C346.3438,117.9807 346.3578,117.9587 346.3728,117.9367 C346.3868,117.9157 346.4008,117.8927 346.4148,117.8707 C346.4428,117.8247 346.4688,117.7787 346.4948,117.7317 C346.5448,117.6417 346.5908,117.5487 346.6318,117.4537 C346.6748,117.3547 346.7138,117.2547 346.7488,117.1537 C346.8148,116.9527 346.8638,116.7457 346.8918,116.5367 C346.9058,116.4297 346.9158,116.3217 346.9168,116.2137 C346.9198,116.1107 346.9168,116.0077 346.9088,115.9057 C346.9038,115.8487 346.8958,115.7927 346.8868,115.7367 C346.8788,115.6827 346.8688,115.6297 346.8558,115.5777 C346.8428,115.5277 346.8298,115.4777 346.8138,115.4287 C346.7988,115.3827 346.7828,115.3377 346.7638,115.2927",
    id: "Stroke-394",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.8117,114.9087 C344.8237,114.9737 344.8327,115.0387 344.8377,115.1047 C344.8447,115.1737 344.8487,115.2427 344.8497,115.3127 C344.8507,115.3797 344.8497,115.4467 344.8457,115.5127 C344.8417,115.5817 344.8347,115.6507 344.8277,115.7187 C344.8107,115.8527 344.7857,115.9867 344.7517,116.1177 C344.7187,116.2487 344.6787,116.3787 344.6307,116.5057 C344.5827,116.6327 344.5277,116.7567 344.4647,116.8767 C344.4327,116.9367 344.3997,116.9977 344.3647,117.0557 C344.3467,117.0847 344.3297,117.1137 344.3117,117.1407 C344.2927,117.1687 344.2747,117.1967 344.2557,117.2237 C344.1787,117.3357 344.0947,117.4427 344.0037,117.5427 C343.9127,117.6427 343.8137,117.7367 343.7067,117.8197",
    id: "Stroke-396",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.7639,115.2929 C346.7329,115.2179 346.6959,115.1449 346.6539,115.0759 C346.6109,115.0069 346.5619,114.9409 346.5059,114.8819 C346.4519,114.8209 346.3909,114.7679 346.3239,114.7209 C346.2559,114.6749 346.1849,114.6369 346.1089,114.6079",
    id: "Stroke-398",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.8225,118.2207 C343.8535,118.2957 343.8905,118.3677 343.9335,118.4377 C343.9765,118.5067 344.0245,118.5727 344.0805,118.6317 C344.1345,118.6917 344.1955,118.7457 344.2625,118.7917 C344.3305,118.8387 344.4015,118.8767 344.4775,118.9057",
    id: "Stroke-400",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.3947,95.0903 C397.3487,95.0733 397.3007,95.0593 397.2527,95.0483 C397.2027,95.0373 397.1527,95.0303 397.1007,95.0283 C397.0467,95.0243 396.9937,95.0243 396.9397,95.0293 C396.8837,95.0333 396.8277,95.0423 396.7717,95.0543 C396.7237,95.0653 396.6757,95.0793 396.6287,95.0943 C396.5807,95.1113 396.5327,95.1313 396.4847,95.1523 C396.4367,95.1743 396.3877,95.1993 396.3407,95.2263 C396.2927,95.2543 396.2457,95.2843 396.2007,95.3163 C396.1147,95.3753 396.0337,95.4403 395.9577,95.5103 C395.8787,95.5833 395.8047,95.6613 395.7357,95.7423 C395.6667,95.8223 395.6027,95.9063 395.5427,95.9933 C395.5287,96.0153 395.5137,96.0373 395.4997,96.0593 C395.4857,96.0813 395.4717,96.1033 395.4577,96.1253 C395.4297,96.1713 395.4037,96.2173 395.3767,96.2633 C395.3277,96.3543 395.2817,96.4473 395.2397,96.5423 C395.1977,96.6413 395.1587,96.7413 395.1237,96.8423 C395.0577,97.0423 395.0087,97.2503 394.9807,97.4593 C394.9667,97.5663 394.9567,97.6743 394.9547,97.7823 C394.9527,97.8843 394.9557,97.9883 394.9637,98.0903 C394.9687,98.1473 394.9757,98.2033 394.9857,98.2593 C394.9937,98.3133 395.0037,98.3663 395.0167,98.4193 C395.0287,98.4683 395.0427,98.5183 395.0587,98.5673 C395.0737,98.6133 395.0897,98.6583 395.1087,98.7033",
    id: "Stroke-402",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.7639,99.3881 C395.8099,99.4061 395.8569,99.4191 395.9059,99.4301 C395.9549,99.4411 396.0059,99.4481 396.0569,99.4511 C396.1109,99.4541 396.1639,99.4541 396.2179,99.4501 C396.2749,99.4451 396.3309,99.4361 396.3859,99.4241 C396.4349,99.4131 396.4819,99.4001 396.5289,99.3841 C396.5779,99.3671 396.6259,99.3481 396.6729,99.3261 C396.7219,99.3041 396.7699,99.2801 396.8169,99.2531 C396.8659,99.2251 396.9119,99.1951 396.9579,99.1631 C397.0429,99.1041 397.1239,99.0381 397.2009,98.9681 C397.2799,98.8961 397.3539,98.8181 397.4229,98.7361 C397.4919,98.6561 397.5549,98.5721 397.6149,98.4851 C397.6289,98.4631 397.6439,98.4421 397.6589,98.4201 C397.6719,98.3981 397.6859,98.3761 397.7009,98.3531 C397.7289,98.3081 397.7549,98.2621 397.7809,98.2151 C397.8299,98.1241 397.8759,98.0311 397.9179,97.9361 C397.9609,97.8381 397.9999,97.7371 398.0339,97.6361 C398.0999,97.4361 398.1489,97.2281 398.1769,97.0201 C398.1919,96.9121 398.2009,96.8051 398.2029,96.6961 C398.2049,96.5941 398.2029,96.4911 398.1939,96.3881 C398.1889,96.3321 398.1819,96.2751 398.1729,96.2191 C398.1639,96.1661 398.1539,96.1131 398.1409,96.0601 C398.1289,96.0101 398.1159,95.9611 398.0999,95.9121 C398.0849,95.8661 398.0689,95.8201 398.0489,95.7761",
    id: "Stroke-404",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.0969,95.3916 C396.1099,95.4566 396.1179,95.5216 396.1239,95.5876 C396.1299,95.6566 396.1349,95.7256 396.1359,95.7956 C396.1369,95.8626 396.1349,95.9296 396.1309,95.9956 C396.1279,96.0646 396.1209,96.1326 396.1139,96.2016 C396.0969,96.3356 396.0719,96.4696 396.0379,96.6006 C396.0049,96.7316 395.9639,96.8616 395.9159,96.9876 C395.8679,97.1146 395.8129,97.2386 395.7499,97.3596 C395.7189,97.4196 395.6849,97.4796 395.6499,97.5386 C395.6329,97.5676 395.6159,97.5956 395.5969,97.6236 C395.5789,97.6516 395.5609,97.6796 395.5409,97.7066 C395.4649,97.8186 395.3809,97.9256 395.2889,98.0256 C395.1989,98.1256 395.0989,98.2186 394.9929,98.3026",
    id: "Stroke-406",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.049,95.7758 C398.018,95.7008 397.982,95.6278 397.939,95.5588 C397.896,95.4888 397.847,95.4238 397.792,95.3638 C397.737,95.3038 397.676,95.2508 397.61,95.2038 C397.542,95.1578 397.471,95.1198 397.395,95.0898",
    id: "Stroke-408",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.1086,98.7036 C395.1396,98.7786 395.1766,98.8506 395.2186,98.9206 C395.2616,98.9896 395.3106,99.0546 395.3666,99.1146 C395.4206,99.1746 395.4816,99.2286 395.5486,99.2746 C395.6156,99.3216 395.6876,99.3596 395.7636,99.3886",
    id: "Stroke-410",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1096,293.2373 C238.0636,293.2193 238.0166,293.2063 237.9676,293.1953 C237.9186,293.1843 237.8676,293.1773 237.8166,293.1753 C237.7626,293.1713 237.7096,293.1723 237.6556,293.1763 C237.5986,293.1803 237.5436,293.1893 237.4876,293.2023 C237.4396,293.2123 237.3916,293.2253 237.3446,293.2423 C237.2966,293.2583 237.2486,293.2773 237.2006,293.2993 C237.1516,293.3213 237.1036,293.3453 237.0566,293.3733 C237.0086,293.4003 236.9616,293.4303 236.9156,293.4633 C236.8306,293.5213 236.7496,293.5883 236.6726,293.6583 C236.5936,293.7303 236.5196,293.8073 236.4506,293.8893 C236.3826,293.9693 236.3186,294.0533 236.2586,294.1403 C236.2446,294.1623 236.2296,294.1833 236.2156,294.2063 C236.2016,294.2273 236.1876,294.2503 236.1736,294.2723 C236.1456,294.3173 236.1186,294.3643 236.0926,294.4113 C236.0436,294.5023 235.9976,294.5943 235.9556,294.6893 C235.9126,294.7883 235.8746,294.8883 235.8396,294.9903 C235.7736,295.1893 235.7246,295.3973 235.6966,295.6063 C235.6816,295.7133 235.6726,295.8213 235.6706,295.9283 C235.6686,296.0323 235.6716,296.1343 235.6796,296.2373 C235.6846,296.2943 235.6916,296.3503 235.7006,296.4063 C235.7096,296.4603 235.7196,296.5123 235.7326,296.5653 C235.7446,296.6153 235.7576,296.6653 235.7746,296.7143 C235.7896,296.7593 235.8056,296.8053 235.8246,296.8503",
    id: "Stroke-412",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.4797,297.5351 C236.5257,297.5531 236.5727,297.5661 236.6217,297.5771 C236.6707,297.5881 236.7217,297.5951 236.7727,297.5981 C236.8267,297.6011 236.8797,297.6001 236.9337,297.5971 C236.9907,297.5921 237.0457,297.5831 237.1017,297.5711 C237.1497,297.5601 237.1977,297.5471 237.2447,297.5311 C237.2927,297.5141 237.3407,297.4951 237.3887,297.4731 C237.4377,297.4511 237.4857,297.4271 237.5327,297.3991 C237.5807,297.3721 237.6277,297.3421 237.6737,297.3091 C237.7587,297.2511 237.8397,297.1851 237.9167,297.1151 C237.9957,297.0431 238.0697,296.9651 238.1387,296.8841 C238.2077,296.8031 238.2707,296.7191 238.3307,296.6321 C238.3447,296.6101 238.3597,296.5891 238.3737,296.5661 C238.3877,296.5451 238.4017,296.5221 238.4157,296.5011 C238.4437,296.4551 238.4697,296.4081 238.4967,296.3621 C238.5457,296.2711 238.5917,296.1791 238.6337,296.0831 C238.6767,295.9841 238.7147,295.8851 238.7497,295.7831 C238.8157,295.5831 238.8647,295.3761 238.8927,295.1671 C238.9077,295.0591 238.9167,294.9521 238.9187,294.8441 C238.9207,294.7401 238.9177,294.6381 238.9097,294.5351 C238.9047,294.4781 238.8977,294.4221 238.8877,294.3661 C238.8797,294.3121 238.8697,294.2601 238.8567,294.2071 C238.8447,294.1571 238.8317,294.1071 238.8147,294.0581 C238.7997,294.0131 238.7837,293.9671 238.7647,293.9231",
    id: "Stroke-414",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.8127,293.538 C236.8247,293.603 236.8337,293.669 236.8397,293.734 C236.8457,293.804 236.8497,293.873 236.8507,293.942 C236.8517,294.009 236.8507,294.076 236.8467,294.142 C236.8427,294.211 236.8367,294.28 236.8287,294.348 C236.8117,294.482 236.7867,294.616 236.7537,294.747 C236.7207,294.879 236.6797,295.009 236.6317,295.135 C236.5837,295.262 236.5287,295.386 236.4657,295.506 C236.4347,295.566 236.4007,295.627 236.3657,295.685 C236.3487,295.714 236.3307,295.743 236.3127,295.77 C236.2937,295.799 236.2767,295.826 236.2567,295.853 C236.1807,295.965 236.0957,296.072 236.0047,296.172 C235.9147,296.272 235.8147,296.366 235.7087,296.449",
    id: "Stroke-416",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7649,293.9228 C238.7339,293.8478 238.6969,293.7748 238.6549,293.7058 C238.6119,293.6368 238.5629,293.5708 238.5079,293.5118 C238.4529,293.4508 238.3919,293.3978 238.3249,293.3508 C238.2579,293.3048 238.1859,293.2668 238.1099,293.2368",
    id: "Stroke-418",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.8245,296.8505 C235.8555,296.9255 235.8925,296.9975 235.9345,297.0675 C235.9775,297.1365 236.0265,297.2025 236.0815,297.2615 C236.1365,297.3215 236.1975,297.3745 236.2645,297.4215 C236.3315,297.4675 236.4035,297.5055 236.4795,297.5355",
    id: "Stroke-420",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.3625,273.5566 C289.3165,273.5386 289.2685,273.5256 289.2205,273.5146 C289.1715,273.5036 289.1205,273.4966 289.0685,273.4946 C289.0145,273.4906 288.9615,273.4916 288.9075,273.4956 C288.8515,273.4996 288.7955,273.5086 288.7405,273.5206 C288.6915,273.5316 288.6435,273.5446 288.5965,273.5616 C288.5485,273.5776 288.5005,273.5966 288.4535,273.6186 C288.4045,273.6406 288.3555,273.6646 288.3095,273.6926 C288.2605,273.7196 288.2135,273.7496 288.1685,273.7826 C288.0825,273.8406 288.0015,273.9076 287.9255,273.9766 C287.8465,274.0496 287.7725,274.1266 287.7035,274.2086 C287.6345,274.2886 287.5705,274.3726 287.5115,274.4596 C287.4965,274.4816 287.4825,274.5026 287.4675,274.5256 C287.4535,274.5466 287.4395,274.5696 287.4255,274.5916 C287.3975,274.6366 287.3715,274.6836 287.3445,274.7306 C287.2955,274.8216 287.2495,274.9136 287.2085,275.0086 C287.1655,275.1076 287.1265,275.2076 287.0915,275.3086 C287.0255,275.5086 286.9765,275.7166 286.9485,275.9256 C286.9345,276.0326 286.9245,276.1406 286.9235,276.2476 C286.9205,276.3516 286.9235,276.4536 286.9315,276.5566 C286.9365,276.6136 286.9435,276.6696 286.9535,276.7256 C286.9615,276.7796 286.9715,276.8316 286.9845,276.8846 C286.9965,276.9346 287.0105,276.9846 287.0265,277.0336 C287.0415,277.0786 287.0575,277.1246 287.0765,277.1696",
    id: "Stroke-422",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.7317,277.8544 C287.7777,277.8724 287.8247,277.8854 287.8737,277.8964 C287.9227,277.9074 287.9737,277.9144 288.0247,277.9174 C288.0787,277.9204 288.1317,277.9194 288.1857,277.9164 C288.2427,277.9114 288.2987,277.9024 288.3537,277.8904 C288.4027,277.8794 288.4497,277.8664 288.4967,277.8504 C288.5457,277.8334 288.5937,277.8144 288.6407,277.7924 C288.6897,277.7704 288.7377,277.7464 288.7847,277.7184 C288.8337,277.6914 288.8797,277.6614 288.9257,277.6284 C289.0107,277.5704 289.0917,277.5044 289.1687,277.4344 C289.2477,277.3624 289.3217,277.2844 289.3907,277.2024 C289.4597,277.1224 289.5237,277.0384 289.5827,276.9514 C289.5967,276.9294 289.6117,276.9084 289.6267,276.8854 C289.6397,276.8644 289.6547,276.8414 289.6687,276.8204 C289.6967,276.7744 289.7227,276.7274 289.7487,276.6804 C289.7977,276.5904 289.8437,276.4974 289.8857,276.4024 C289.9287,276.3034 289.9677,276.2044 290.0017,276.1024 C290.0687,275.9024 290.1167,275.6954 290.1447,275.4864 C290.1597,275.3784 290.1687,275.2704 290.1707,275.1634 C290.1737,275.0594 290.1707,274.9574 290.1617,274.8544 C290.1567,274.7974 290.1497,274.7414 290.1407,274.6854 C290.1317,274.6314 290.1217,274.5794 290.1087,274.5264 C290.0967,274.4764 290.0837,274.4264 290.0677,274.3774 C290.0527,274.3324 290.0367,274.2864 290.0177,274.2424",
    id: "Stroke-424",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.0647,273.8574 C288.0777,273.9224 288.0857,273.9884 288.0917,274.0534 C288.0987,274.1234 288.1027,274.1924 288.1037,274.2614 C288.1047,274.3284 288.1027,274.3954 288.0987,274.4614 C288.0957,274.5304 288.0887,274.5994 288.0817,274.6674 C288.0647,274.8014 288.0397,274.9354 288.0057,275.0664 C287.9727,275.1984 287.9317,275.3284 287.8837,275.4544 C287.8357,275.5814 287.7807,275.7054 287.7187,275.8254 C287.6867,275.8854 287.6537,275.9464 287.6177,276.0044 C287.6007,276.0334 287.5837,276.0624 287.5647,276.0894 C287.5467,276.1184 287.5287,276.1454 287.5097,276.1724 C287.4327,276.2844 287.3487,276.3914 287.2567,276.4914 C287.1667,276.5914 287.0667,276.6854 286.9607,276.7684",
    id: "Stroke-426",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.0178,274.2421 C289.9858,274.1671 289.9498,274.0941 289.9068,274.0251 C289.8638,273.9561 289.8148,273.8901 289.7598,273.8311 C289.7058,273.7701 289.6438,273.7171 289.5778,273.6701 C289.5098,273.6241 289.4388,273.5861 289.3628,273.5561",
    id: "Stroke-428",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.0764,277.1699 C287.1074,277.2449 287.1444,277.3169 287.1864,277.3869 C287.2294,277.4559 287.2784,277.5219 287.3344,277.5809 C287.3884,277.6409 287.4494,277.6939 287.5164,277.7409 C287.5834,277.7869 287.6554,277.8249 287.7314,277.8549",
    id: "Stroke-430",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.1086,252.0664 C346.0626,252.0484 346.0156,252.0354 345.9666,252.0244 C345.9176,252.0134 345.8666,252.0064 345.8146,252.0034 C345.7616,252.0004 345.7076,252.0004 345.6546,252.0044 C345.5976,252.0094 345.5416,252.0174 345.4866,252.0304 C345.4376,252.0414 345.3906,252.0544 345.3436,252.0704 C345.2946,252.0874 345.2466,252.1064 345.1996,252.1284 C345.1506,252.1504 345.1026,252.1744 345.0556,252.2014 C345.0066,252.2294 344.9606,252.2594 344.9146,252.2914 C344.8296,252.3504 344.7486,252.4164 344.6716,252.4864 C344.5926,252.5584 344.5186,252.6364 344.4496,252.7184 C344.3806,252.7984 344.3166,252.8824 344.2576,252.9694 C344.2426,252.9914 344.2286,253.0124 344.2136,253.0344 C344.2006,253.0564 344.1856,253.0784 344.1716,253.1004 C344.1436,253.1464 344.1176,253.1924 344.0916,253.2394 C344.0426,253.3304 343.9956,253.4234 343.9546,253.5184 C343.9116,253.6164 343.8726,253.7164 343.8386,253.8184 C343.7716,254.0184 343.7226,254.2254 343.6956,254.4344 C343.6806,254.5424 343.6716,254.6504 343.6696,254.7574 C343.6666,254.8604 343.6696,254.9634 343.6786,255.0664 C343.6826,255.1234 343.6906,255.1784 343.6996,255.2354 C343.7086,255.2884 343.7186,255.3414 343.7316,255.3944 C343.7436,255.4444 343.7566,255.4934 343.7726,255.5434 C343.7876,255.5884 343.8036,255.6334 343.8226,255.6784",
    id: "Stroke-432",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.4778,256.3642 C344.5238,256.3812 344.5718,256.3952 344.6198,256.4052 C344.6688,256.4172 344.7198,256.4242 344.7718,256.4262 C344.8258,256.4292 344.8788,256.4292 344.9328,256.4262 C344.9898,256.4212 345.0448,256.4122 345.0998,256.3992 C345.1488,256.3882 345.1968,256.3752 345.2438,256.3592 C345.2918,256.3432 345.3398,256.3242 345.3868,256.3022 C345.4358,256.2802 345.4838,256.2552 345.5308,256.2282 C345.5798,256.2002 345.6268,256.1712 345.6718,256.1382 C345.7578,256.0792 345.8378,256.0132 345.9148,255.9442 C345.9938,255.8712 346.0688,255.7932 346.1378,255.7122 C346.2058,255.6322 346.2698,255.5482 346.3288,255.4612 C346.3438,255.4392 346.3578,255.4172 346.3728,255.3952 C346.3868,255.3742 346.4008,255.3512 346.4148,255.3292 C346.4428,255.2832 346.4688,255.2372 346.4948,255.1902 C346.5448,255.0992 346.5908,255.0072 346.6318,254.9122 C346.6748,254.8132 346.7138,254.7132 346.7488,254.6112 C346.8148,254.4122 346.8638,254.2042 346.8918,253.9962 C346.9058,253.8872 346.9158,253.7802 346.9168,253.6722 C346.9198,253.5692 346.9168,253.4662 346.9088,253.3642 C346.9038,253.3072 346.8958,253.2512 346.8868,253.1952 C346.8788,253.1412 346.8688,253.0882 346.8558,253.0362 C346.8428,252.9862 346.8298,252.9362 346.8138,252.8872 C346.7988,252.8412 346.7828,252.7962 346.7638,252.7512",
    id: "Stroke-434",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.8117,252.3671 C344.8237,252.4311 344.8327,252.4971 344.8377,252.5631 C344.8447,252.6321 344.8487,252.7021 344.8497,252.7711 C344.8507,252.8381 344.8497,252.9041 344.8457,252.9711 C344.8417,253.0401 344.8347,253.1081 344.8277,253.1771 C344.8107,253.3111 344.7857,253.4451 344.7517,253.5761 C344.7187,253.7071 344.6787,253.8371 344.6307,253.9641 C344.5827,254.0911 344.5277,254.2151 344.4647,254.3351 C344.4327,254.3951 344.3997,254.4561 344.3647,254.5141 L344.3117,254.5991 C344.2927,254.6271 344.2747,254.6551 344.2557,254.6821 C344.1787,254.7941 344.0947,254.9011 344.0037,255.0011 C343.9127,255.1001 343.8137,255.1941 343.7067,255.2781",
    id: "Stroke-436",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.7639,252.7509 C346.7329,252.6769 346.6959,252.6039 346.6539,252.5339 C346.6109,252.4649 346.5619,252.3999 346.5059,252.3399 C346.4519,252.2789 346.3909,252.2259 346.3239,252.1799 C346.2559,252.1329 346.1849,252.0949 346.1089,252.0659",
    id: "Stroke-438",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.8225,255.6787 C343.8535,255.7537 343.8905,255.8257 343.9335,255.8957 C343.9765,255.9647 344.0245,256.0307 344.0805,256.0897 C344.1345,256.1507 344.1955,256.2037 344.2625,256.2497 C344.3305,256.2967 344.4015,256.3347 344.4775,256.3647",
    id: "Stroke-440",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.3947,232.5488 C397.3487,232.5308 397.3007,232.5178 397.2527,232.5068 C397.2027,232.4958 397.1527,232.4888 397.1007,232.4868 C397.0467,232.4828 396.9937,232.4838 396.9397,232.4868 C396.8837,232.4918 396.8277,232.5008 396.7717,232.5128 C396.7237,232.5238 396.6757,232.5368 396.6287,232.5528 C396.5807,232.5698 396.5327,232.5888 396.4847,232.6108 C396.4367,232.6328 396.3877,232.6568 396.3407,232.6848 C396.2927,232.7118 396.2457,232.7418 396.2007,232.7748 C396.1147,232.8328 396.0337,232.8988 395.9577,232.9688 C395.8787,233.0418 395.8047,233.1188 395.7357,233.2008 C395.6667,233.2808 395.6027,233.3648 395.5427,233.4518 C395.5287,233.4738 395.5137,233.4948 395.4997,233.5178 C395.4857,233.5388 395.4717,233.5618 395.4577,233.5838 C395.4297,233.6288 395.4037,233.6758 395.3767,233.7218 C395.3277,233.8128 395.2817,233.9058 395.2397,234.0008 C395.1977,234.0998 395.1587,234.1988 395.1237,234.3008 C395.0577,234.5008 395.0087,234.7078 394.9807,234.9168 C394.9667,235.0248 394.9567,235.1328 394.9547,235.2398 C394.9527,235.3438 394.9557,235.4458 394.9637,235.5488 C394.9687,235.6058 394.9757,235.6618 394.9857,235.7178 C394.9937,235.7718 395.0037,235.8238 395.0167,235.8768 C395.0287,235.9268 395.0427,235.9768 395.0587,236.0258 C395.0737,236.0708 395.0897,236.1168 395.1087,236.1618",
    id: "Stroke-442",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.7639,236.8466 C395.8099,236.8646 395.8569,236.8776 395.9059,236.8886 C395.9549,236.8996 396.0059,236.9066 396.0569,236.9096 C396.1109,236.9126 396.1639,236.9116 396.2179,236.9086 C396.2749,236.9036 396.3309,236.8946 396.3859,236.8816 C396.4349,236.8716 396.4819,236.8586 396.5289,236.8416 C396.5779,236.8256 396.6259,236.8066 396.6729,236.7846 C396.7219,236.7626 396.7699,236.7386 396.8169,236.7106 C396.8659,236.6836 396.9119,236.6536 396.9579,236.6206 C397.0429,236.5626 397.1239,236.4966 397.2009,236.4266 C397.2799,236.3546 397.3539,236.2766 397.4229,236.1946 C397.4919,236.1146 397.5549,236.0306 397.6149,235.9436 C397.6289,235.9216 397.6439,235.9006 397.6589,235.8776 C397.6719,235.8566 397.6859,235.8336 397.7009,235.8126 C397.7289,235.7666 397.7549,235.7196 397.7809,235.6726 C397.8299,235.5816 397.8759,235.4896 397.9179,235.3946 C397.9609,235.2956 397.9999,235.1956 398.0339,235.0946 C398.0999,234.8946 398.1489,234.6866 398.1769,234.4786 C398.1919,234.3706 398.2009,234.2626 398.2029,234.1556 C398.2049,234.0516 398.2029,233.9496 398.1939,233.8466 C398.1889,233.7896 398.1819,233.7336 398.1729,233.6776 C398.1639,233.6236 398.1539,233.5716 398.1409,233.5186 C398.1289,233.4686 398.1159,233.4186 398.0999,233.3696 C398.0849,233.3246 398.0689,233.2786 398.0489,233.2346",
    id: "Stroke-444",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.0969,232.8496 C396.1099,232.9146 396.1179,232.9806 396.1239,233.0456 C396.1299,233.1156 396.1349,233.1846 396.1359,233.2536 C396.1369,233.3206 396.1349,233.3876 396.1309,233.4536 C396.1279,233.5226 396.1209,233.5906 396.1139,233.6596 C396.0969,233.7936 396.0719,233.9276 396.0379,234.0586 C396.0049,234.1906 395.9639,234.3196 395.9159,234.4466 C395.8679,234.5736 395.8129,234.6976 395.7499,234.8176 C395.7189,234.8776 395.6849,234.9386 395.6499,234.9966 C395.6329,235.0256 395.6159,235.0536 395.5969,235.0816 C395.5789,235.1106 395.5609,235.1376 395.5409,235.1646 C395.4649,235.2766 395.3809,235.3836 395.2889,235.4836 C395.1989,235.5836 395.0989,235.6766 394.9929,235.7606",
    id: "Stroke-446",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.049,233.2343 C398.018,233.1593 397.982,233.0863 397.939,233.0163 C397.896,232.9473 397.847,232.8823 397.792,232.8233 C397.737,232.7623 397.676,232.7093 397.61,232.6623 C397.542,232.6163 397.471,232.5783 397.395,232.5483",
    id: "Stroke-448",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.1086,236.1621 C395.1396,236.2361 395.1766,236.3091 395.2186,236.3791 C395.2616,236.4471 395.3106,236.5131 395.3666,236.5731 C395.4206,236.6331 395.4816,236.6861 395.5486,236.7331 C395.6156,236.7791 395.6876,236.8171 395.7636,236.8471",
    id: "Stroke-450",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.8909,
    y1: 279.5039,
    x2: 120.4489,
    y2: 279.2919,
    id: "Stroke-452",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.9397,
    y1: 190.0917,
    x2: 260.9377,
    y2: 190.0917,
    id: "Stroke-454",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.5906,259.0976 C201.6366,259.1246 201.6836,259.1476 201.7306,259.1656 C201.7576,259.1756 201.7846,259.1846 201.8116,259.1916 C201.8296,259.1966 201.8476,259.2006 201.8666,259.2026 C201.8756,259.2046 201.8856,259.2066 201.8946,259.2076 C201.9126,259.2106 201.9306,259.2116 201.9486,259.2136 L201.9796,259.2136 C202.0086,259.2136 202.0376,259.2126 202.0656,259.2086 C202.1086,259.2026 202.1496,259.1926 202.1896,259.1766",
    id: "Stroke-456",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.1897,259.1767 C202.2227,259.1647 202.2537,259.1497 202.2837,259.1307 C202.3177,259.1107 202.3507,259.0857 202.3797,259.0577 C202.4017,259.0367 202.4237,259.0147 202.4427,258.9897 C202.4547,258.9757 202.4657,258.9607 202.4767,258.9467 C202.4837,258.9357 202.4907,258.9247 202.4977,258.9127 C202.5307,258.8597 202.5587,258.7997 202.5807,258.7367 C202.5997,258.6777 202.6157,258.6157 202.6257,258.5507 C202.6357,258.4837 202.6417,258.4137 202.6417,258.3417",
    id: "Stroke-458",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.0559,258.6679 C197.0559,258.7889 197.0649,258.9119 197.0809,259.0369 C197.0989,259.1699 197.1259,259.3029 197.1619,259.4359 C197.1999,259.5729 197.2459,259.7089 197.3019,259.8419 C197.3589,259.9769 197.4239,260.1069 197.4969,260.2309 C197.5469,260.3139 197.5989,260.3939 197.6549,260.4699 C197.7059,260.5399 197.7599,260.6069 197.8159,260.6699 C197.8789,260.7399 197.9439,260.8069 198.0109,260.8669 C198.0999,260.9469 198.1929,261.0179 198.2879,261.0769 C198.3819,261.1369 198.4779,261.1849 198.5749,261.2219 C198.6209,261.2389 198.6679,261.2539 198.7149,261.2659 C198.7459,261.2739 198.7789,261.2809 198.8099,261.2869 L198.8469,261.2929",
    id: "Stroke-460",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8469,261.2929 C198.9179,261.3039 198.9899,261.3139 199.0609,261.3249",
    id: "Stroke-462",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.0613,261.3251 C199.0653,261.3251 199.0703,261.3261 199.0743,261.3261 C199.1073,261.3311 199.1423,261.3341 199.1763,261.3361 C199.2103,261.3381 199.2453,261.3381 199.2793,261.3371 C199.3133,261.3351 199.3483,261.3321 199.3813,261.3271 C199.4583,261.3161 199.5323,261.2981 199.6033,261.2701",
    id: "Stroke-464",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6037,261.2705 C199.6287,261.2605 199.6547,261.2495 199.6797,261.2385 C199.7117,261.2235 199.7427,261.2075 199.7727,261.1875 C199.8337,261.1505 199.8917,261.1075 199.9447,261.0565 C199.9797,261.0245 200.0137,260.9895 200.0447,260.9525 C200.0857,260.9035 200.1237,260.8505 200.1587,260.7945 C200.1787,260.7615 200.1977,260.7275 200.2157,260.6925 C200.2517,260.6235 200.2827,260.5485 200.3097,260.4705 C200.3217,260.4325 200.3337,260.3935 200.3447,260.3535 C200.3657,260.2765 200.3827,260.1955 200.3957,260.1125 C200.4017,260.0715 200.4067,260.0305 200.4107,259.9885 C200.4177,259.9085 200.4217,259.8265 200.4217,259.7415",
    id: "Stroke-466",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.1726,257.2451 C201.2056,257.2331 201.2386,257.2251 201.2736,257.2211 C201.3096,257.2171 201.3476,257.2181 201.3836,257.2231 C201.4186,257.2271 201.4516,257.2361 201.4846,257.2461 C201.5196,257.2591 201.5536,257.2731 201.5866,257.2911 C201.6166,257.3071 201.6466,257.3261 201.6746,257.3481 C201.7046,257.3681 201.7326,257.3911 201.7596,257.4161 C201.7856,257.4401 201.8106,257.4661 201.8336,257.4911 L201.8516,257.5121 C201.8566,257.5181 201.8626,257.5251 201.8686,257.5321 C201.8806,257.5471 201.8916,257.5601 201.9026,257.5761 C201.9236,257.6041 201.9436,257.6331 201.9616,257.6631 C201.9806,257.6941 201.9986,257.7251 202.0156,257.7581 C202.0486,257.8211 202.0756,257.8881 202.0996,257.9561 C202.1226,258.0231 202.1396,258.0931 202.1516,258.1631 C202.1586,258.1991 202.1636,258.2361 202.1666,258.2721 C202.1696,258.3071 202.1716,258.3421 202.1716,258.3771",
    id: "Stroke-468",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.9953,257.0322 C197.9703,257.0422 197.9443,257.0532 197.9193,257.0642 C197.8883,257.0802 197.8563,257.0962 197.8263,257.1152 C197.7653,257.1522 197.7083,257.1952 197.6543,257.2462 C197.6193,257.2782 197.5853,257.3132 197.5543,257.3502 C197.5543,257.3512 197.5543,257.3512 197.5543,257.3512",
    id: "Stroke-470",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5539,257.3515 C197.5079,257.4075 197.4609,257.4615 197.4139,257.5175",
    id: "Stroke-472",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.4143,257.5175 C197.4103,257.5235 197.4053,257.5285 197.4013,257.5335 C197.3813,257.5575 197.3623,257.5835 197.3443,257.6095 C197.3313,257.6285 197.3183,257.6475 197.3073,257.6665 C197.2493,257.7595 197.2013,257.8635 197.1633,257.9745 C197.1283,258.0765 197.1023,258.1845 197.0833,258.2985 C197.0653,258.4165 197.0563,258.5395 197.0563,258.6675",
    id: "Stroke-474",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.3196,256.8837 C201.2866,256.8967 201.2556,256.9107 201.2256,256.9297 C201.1916,256.9497 201.1586,256.9747 201.1296,257.0027 C201.1076,257.0237 201.0856,257.0457 201.0666,257.0707 C201.0546,257.0837 201.0436,257.0987 201.0326,257.1137 C201.0256,257.1247 201.0186,257.1367 201.0116,257.1477 C200.9786,257.2007 200.9506,257.2607 200.9286,257.3237 C200.9266,257.3287 200.9256,257.3347 200.9236,257.3397",
    id: "Stroke-476",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.6418,258.3417 C202.6418,258.2727 202.6368,258.2027 202.6268,258.1317 C202.6168,258.0567 202.6018,257.9817 202.5808,257.9067 C202.5598,257.8287 202.5338,257.7517 202.5018,257.6777 C202.4708,257.6017 202.4338,257.5277 202.3918,257.4577 C202.3638,257.4107 202.3348,257.3647 202.3038,257.3217 C202.2738,257.2827 202.2438,257.2447 202.2118,257.2087 C202.1758,257.1687 202.1398,257.1317 202.1008,257.0977 C202.0508,257.0517 201.9968,257.0117 201.9428,256.9777 C201.8888,256.9437 201.8338,256.9157 201.7778,256.8947 C201.7508,256.8847 201.7248,256.8757 201.6978,256.8687 C201.6788,256.8637 201.6608,256.8607 201.6418,256.8567 C201.6328,256.8557 201.6238,256.8537 201.6148,256.8527 C201.5968,256.8497 201.5788,256.8477 201.5598,256.8477 C201.5498,256.8467 201.5398,256.8467 201.5288,256.8457 C201.4998,256.8457 201.4718,256.8477 201.4438,256.8517 C201.4008,256.8587 201.3588,256.8677 201.3198,256.8837",
    id: "Stroke-478",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.1711,258.3769 C202.1711,258.4389 202.1661,258.5029 202.1541,258.5639 C202.1431,258.6249 202.1251,258.6869 202.0991,258.7429 C202.0731,258.8009 202.0391,258.8549 201.9951,258.8989 C201.9511,258.9449 201.8991,258.9809 201.8391,259.0029",
    id: "Stroke-480",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5569,
    y1: 96.7256,
    x2: 418.5569,
    y2: 94.3746,
    id: "Stroke-482",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.3703,
    y1: 231.5156,
    x2: 417.5003,
    y2: 231.1856,
    id: "Stroke-484",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.799,
    y1: 287.5468,
    x2: 353.799,
    y2: 287.5478,
    id: "Stroke-486",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.2258,
    y1: 287.5898,
    x2: 353.2258,
    y2: 287.6248,
    id: "Stroke-488",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.6604,
    y1: 284.9345,
    x2: 363.6604,
    y2: 284.8985,
    id: "Stroke-490",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.1526,
    y1: 171.0883,
    x2: 215.4316,
    y2: 171.1943,
    id: "Stroke-492",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.4514,
    y1: 314.7216,
    x2: 213.3554,
    y2: 314.7576,
    id: "Stroke-494",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.8801,
    y1: 292.0595,
    x2: 258.8751,
    y2: 292.7625,
    id: "Stroke-496",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.8801,
    y1: 292.0595,
    x2: 257.9911,
    y2: 291.7115,
    id: "Stroke-498",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.7405,
    y1: 270.4833,
    x2: 314.8505,
    y2: 270.1353,
    id: "Stroke-500",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.635,
    y1: 112.3672,
    x2: 213.635,
    y2: 112.5792,
    id: "Stroke-502",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.635,
    y1: 112.3672,
    x2: 215.432,
    y2: 113.0492,
    id: "Stroke-504",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.0119,
    y1: 239.1201,
    x2: 372.0119,
    y2: 248.4451,
    id: "Stroke-506",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.1526,
    y1: 222.7822,
    x2: 223.1526,
    y2: 219.7472,
    id: "Stroke-508",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.0481,
    y1: 235.7177,
    x2: 259.0481,
    y2: 233.3667,
    id: "Stroke-510",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.8762,
    y1: 222.79,
    x2: 372.8642,
    y2: 236.446,
    id: "Stroke-512",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.1438,
    y1: 51.8403,
    x2: 373.1438,
    y2: 52.0523,
    id: "Stroke-514",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.4704,367.5058 C146.4904,367.5188 146.5104,367.5298 146.5304,367.5428 C146.7214,367.6618 146.9144,367.7748 147.1084,367.8788 C147.4834,368.0798 147.8624,368.2538 148.2414,368.3988 C148.6204,368.5418 149.0004,368.6558 149.3784,368.7388 C149.5734,368.7818 149.7674,368.8178 149.9624,368.8438 C149.9794,368.8468 149.9974,368.8488 150.0154,368.8518",
    id: "Stroke-516",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.6613,
    y1: 159.2197,
    x2: 418.5573,
    y2: 172.8407,
    id: "Stroke-518",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.5569,
    y1: 175.1914,
    x2: 418.5569,
    y2: 172.8404,
    id: "Stroke-520",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.6028,
    y1: 248.9062,
    x2: 372.5978,
    y2: 249.6092,
    id: "Stroke-522",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.6028,
    y1: 248.9062,
    x2: 371.7128,
    y2: 248.5582,
    id: "Stroke-524",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.3142,243.6357 C152.3852,243.6467 152.4572,243.6567 152.5292,243.6677",
    id: "Stroke-526",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.529,243.6679 C152.533,243.6679 152.537,243.6689 152.541,243.6689 C152.575,243.6739 152.609,243.6769 152.643,243.6789 C152.678,243.6809 152.713,243.6809 152.746,243.6799 C152.781,243.6779 152.815,243.6749 152.849,243.6709 C152.925,243.6599 153,243.6409 153.071,243.6129",
    id: "Stroke-528",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.0178,
    y1: 74.8437,
    x2: 313.9408,
    y2: 74.0927,
    id: "Stroke-530",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.2453,
    y1: 77.8637,
    x2: 122.2453,
    y2: 77.9007,
    id: "Stroke-532",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.9406,
    y1: 74.0927,
    x2: 313.9406,
    y2: 74.1147,
    id: "Stroke-534",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.5393,
    y1: 165.142,
    x2: 311.5383,
    y2: 165.141,
    id: "Stroke-536",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.6106,154.5439 C283.6096,154.5439 283.6096,154.5439 283.6096,154.5439",
    id: "Stroke-538",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.1203,
    y1: 165.3627,
    x2: 316.0173,
    y2: 166.8417,
    id: "Stroke-540",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.0295,
    y1: 153.1855,
    x2: 283.6105,
    y2: 154.5435,
    id: "Stroke-542",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 284.1916,
    y1: 154.7646,
    x2: 311.5396,
    y2: 165.1416,
    id: "Stroke-544",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 284.1916,
    y1: 154.7646,
    x2: 284.1926,
    y2: 154.7646,
    id: "Stroke-546",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.1203,
    y1: 165.3627,
    x2: 312.1213,
    y2: 165.3627,
    id: "Stroke-548",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.0578,241.4414 C155.1038,241.4674 155.1508,241.4904 155.1978,241.5084 C155.2248,241.5184 155.2518,241.5274 155.2788,241.5344 C155.2968,241.5394 155.3158,241.5434 155.3338,241.5464 C155.3438,241.5484 155.3528,241.5494 155.3618,241.5504 C155.3798,241.5534 155.3978,241.5554 155.4158,241.5564 C155.4268,241.5564 155.4368,241.5574 155.4468,241.5574 C155.4758,241.5574 155.5048,241.5554 155.5328,241.5514 C155.5758,241.5454 155.6178,241.5354 155.6578,241.5194",
    id: "Stroke-550",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.6575,241.5195 C155.6895,241.5075 155.7215,241.4925 155.7515,241.4735 C155.7855,241.4535 155.8175,241.4285 155.8475,241.4015 C155.8695,241.3795 155.8905,241.3575 155.9105,241.3325 C155.9225,241.3195 155.9325,241.3045 155.9435,241.2895 C155.9505,241.2785 155.9585,241.2675 155.9655,241.2555 C155.9985,241.2025 156.0255,241.1435 156.0485,241.0795 C156.0675,241.0205 156.0825,240.9585 156.0935,240.8945 C156.1035,240.8275 156.1095,240.7565 156.1095,240.6845",
    id: "Stroke-552",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.5237,241.0107 C150.5237,241.1317 150.5317,241.2557 150.5487,241.3797 C150.5667,241.5127 150.5937,241.6467 150.6287,241.7787 C150.6677,241.9157 150.7137,242.0517 150.7697,242.1847 C150.8257,242.3197 150.8917,242.4497 150.9647,242.5737 C151.0137,242.6567 151.0657,242.7367 151.1217,242.8127 C151.1737,242.8827 151.2277,242.9497 151.2837,243.0127 C151.3457,243.0837 151.4107,243.1497 151.4787,243.2097 C151.5677,243.2897 151.6607,243.3607 151.7557,243.4197 C151.8497,243.4797 151.9457,243.5277 152.0427,243.5647 C152.0887,243.5817 152.1357,243.5967 152.1817,243.6097 C152.2137,243.6167 152.2457,243.6237 152.2777,243.6297 C152.2897,243.6327 152.3017,243.6347 152.3147,243.6357",
    id: "Stroke-554",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.0715,243.6132 C153.0965,243.6032 153.1225,243.5922 153.1475,243.5812 C153.1785,243.5662 153.2105,243.5502 153.2405,243.5312 C153.3015,243.4932 153.3585,243.4502 153.4125,243.4002 C153.4475,243.3672 153.4815,243.3332 153.5125,243.2952 C153.5525,243.2462 153.5915,243.1932 153.6265,243.1362 C153.6465,243.1042 153.6655,243.0702 153.6835,243.0352 C153.7185,242.9662 153.7505,242.8912 153.7765,242.8132 C153.7895,242.7752 153.8015,242.7372 153.8125,242.6972 C153.8335,242.6192 153.8505,242.5392 153.8635,242.4552 C153.8685,242.4152 153.8735,242.3732 153.8785,242.3322 C153.8855,242.2512 153.8895,242.1692 153.8895,242.0852",
    id: "Stroke-556",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6399,239.5878 C154.6729,239.5758 154.7059,239.5678 154.7409,239.5648 C154.7779,239.5608 154.8149,239.5608 154.8509,239.5658 C154.8859,239.5698 154.9189,239.5788 154.9519,239.5898 C154.9869,239.6018 155.0209,239.6158 155.0539,239.6338 C155.0839,239.6498 155.1139,239.6698 155.1419,239.6898 C155.1719,239.7108 155.2009,239.7338 155.2269,239.7588 C155.2529,239.7828 155.2779,239.8088 155.3009,239.8348 C155.3069,239.8408 155.3129,239.8478 155.3189,239.8548 L155.3359,239.8748 L155.3699,239.9188 C155.3909,239.9468 155.4109,239.9768 155.4289,240.0058 C155.4489,240.0368 155.4659,240.0688 155.4829,240.1008 C155.5159,240.1638 155.5439,240.2308 155.5669,240.2988 C155.5899,240.3658 155.6069,240.4358 155.6189,240.5058 C155.6259,240.5418 155.6309,240.5788 155.6339,240.6148 C155.6369,240.6498 155.6389,240.6848 155.6389,240.7198",
    id: "Stroke-558",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.4631,239.375 C151.4371,239.385 151.4121,239.396 151.3871,239.407 C151.3551,239.423 151.3241,239.439 151.2941,239.458 C151.2331,239.495 151.1751,239.539 151.1221,239.589 C151.0871,239.621 151.0531,239.656 151.0221,239.693 L151.0221,239.694",
    id: "Stroke-560",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.0217,239.6943 C150.9747,239.7503 150.9287,239.8053 150.8817,239.8603",
    id: "Stroke-562",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8816,239.8603 C150.8776,239.8663 150.8726,239.8713 150.8686,239.8773 C150.8486,239.9003 150.8296,239.9253 150.8116,239.9533 C150.7986,239.9713 150.7856,239.9903 150.7746,240.0093 C150.7166,240.1033 150.6696,240.2063 150.6306,240.3173 C150.5956,240.4193 150.5696,240.5273 150.5516,240.6413 C150.5326,240.7593 150.5236,240.8833 150.5236,241.0103",
    id: "Stroke-564",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.7869,239.2265 C154.7539,239.2395 154.7229,239.2545 154.6929,239.2725 C154.6589,239.2925 154.6269,239.3175 154.5969,239.3455 C154.5749,239.3665 154.5539,239.3885 154.5339,239.4135 C154.5219,239.4275 154.5109,239.4425 154.5009,239.4565 C154.4929,239.4675 154.4859,239.4795 154.4789,239.4905 C154.4459,239.5435 154.4179,239.6035 154.3959,239.6665 C154.3949,239.6725 154.3929,239.6775 154.3909,239.6825",
    id: "Stroke-566",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.1091,240.6845 C156.1091,240.6165 156.1041,240.5455 156.0941,240.4745 C156.0841,240.4005 156.0691,240.3255 156.0491,240.2495 C156.0271,240.1715 156.0021,240.0945 155.9701,240.0205 C155.9381,239.9445 155.9011,239.8705 155.8591,239.8005 C155.8321,239.7535 155.8021,239.7075 155.7711,239.6655 C155.7411,239.6255 155.7111,239.5875 155.6791,239.5515 C155.6441,239.5115 155.6071,239.4745 155.5681,239.4405 C155.5181,239.3945 155.4641,239.3545 155.4101,239.3205 C155.3571,239.2865 155.3011,239.2585 155.2461,239.2375 C155.2191,239.2275 155.1921,239.2185 155.1651,239.2115 C155.1471,239.2065 155.1281,239.2035 155.1101,239.1995 C155.1001,239.1985 155.0911,239.1965 155.0821,239.1955 C155.0641,239.1935 155.0461,239.1915 155.0281,239.1905 C155.0171,239.1895 155.0071,239.1895 154.9971,239.1895 C154.9671,239.1895 154.9391,239.1915 154.9111,239.1955 C154.8681,239.2005 154.8271,239.2105 154.7871,239.2265",
    id: "Stroke-568",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.6384,240.7197 C155.6384,240.7817 155.6334,240.8457 155.6214,240.9067 C155.6104,240.9687 155.5924,241.0297 155.5664,241.0867 C155.5404,241.1437 155.5064,241.1977 155.4624,241.2417 C155.4184,241.2877 155.3664,241.3237 155.3074,241.3467",
    id: "Stroke-570",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.0481,
    y1: 157.2519,
    x2: 259.0481,
    y2: 154.9009,
    id: "Stroke-572",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.1531,
    y1: 174.7675,
    x2: 259.0481,
    y2: 188.3885,
    id: "Stroke-574",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.2737,
    y1: 282.2285,
    x2: 258.2737,
    y2: 291.6045,
    id: "Stroke-576",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.3703,
    y1: 36.042,
    x2: 418.3703,
    y2: 94.188,
    id: "Stroke-578",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.3703,
    y1: 36.042,
    x2: 416.5743,
    y2: 35.36,
    id: "Stroke-580",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.1438,
    y1: 51.8403,
    x2: 374.9408,
    y2: 52.5223,
    id: "Stroke-582",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.6496,
    y1: 35.936,
    x2: 415.8576,
    y2: 34.876,
    id: "Stroke-584",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.3245,250.2695 C178.3705,250.2965 178.4175,250.3195 178.4645,250.3365 C178.4915,250.3475 178.5185,250.3565 178.5445,250.3635 C178.5635,250.3685 178.5815,250.3725 178.6005,250.3745 C178.6095,250.3765 178.6185,250.3775 178.6285,250.3795 C178.6465,250.3815 178.6645,250.3835 178.6825,250.3845 C178.6925,250.3855 178.7025,250.3855 178.7135,250.3855 C178.7425,250.3855 178.7705,250.3835 178.7995,250.3795 C178.8425,250.3735 178.8835,250.3635 178.9235,250.3485",
    id: "Stroke-586",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.9231,250.3486 C178.9561,250.3356 178.9871,250.3206 179.0181,250.3016 C179.0511,250.2816 179.0841,250.2566 179.1131,250.2296 C179.1361,250.2076 179.1571,250.1856 179.1761,250.1616 C179.1881,250.1476 179.1991,250.1326 179.2101,250.1176 C179.2171,250.1066 179.2241,250.0956 179.2311,250.0836 C179.2641,250.0316 179.2921,249.9716 179.3141,249.9076 C179.3341,249.8496 179.3491,249.7866 179.3591,249.7226 C179.3701,249.6556 179.3751,249.5846 179.3751,249.5126",
    id: "Stroke-588",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7898,249.8388 C173.7898,249.9598 173.7978,250.0838 173.8148,250.2088 C173.8328,250.3418 173.8598,250.4748 173.8958,250.6068 C173.9328,250.7438 173.9798,250.8808 174.0358,251.0128 C174.0928,251.1488 174.1578,251.2778 174.2318,251.4028 C174.2808,251.4848 174.3328,251.5658 174.3888,251.6408 C174.4398,251.7118 174.4938,251.7778 174.5498,251.8418 C174.6118,251.9118 174.6778,251.9778 174.7448,252.0378 C174.8338,252.1188 174.9268,252.1888 175.0218,252.2488 C175.1158,252.3078 175.2118,252.3568 175.3088,252.3928 C175.3548,252.4098 175.4018,252.4248 175.4478,252.4378 C175.4798,252.4458 175.5118,252.4528 175.5438,252.4588 C175.5558,252.4608 175.5678,252.4628 175.5808,252.4648",
    id: "Stroke-590",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5808,252.4648 C175.6518,252.4758 175.7238,252.4858 175.7948,252.4958",
    id: "Stroke-592",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.7952,252.496 C175.7992,252.497 175.8032,252.497 175.8072,252.498 C175.8412,252.503 175.8762,252.506 175.9102,252.508 C175.9442,252.51 175.9782,252.51 176.0122,252.508 C176.0472,252.507 176.0812,252.504 176.1152,252.499 C176.1912,252.488 176.2662,252.47 176.3372,252.442",
    id: "Stroke-594",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3376,252.4423 C176.3636,252.4323 176.3886,252.4213 176.4136,252.4103 C176.4446,252.3943 176.4766,252.3783 176.5066,252.3593 C176.5676,252.3223 176.6256,252.2783 176.6786,252.2283 C176.7136,252.1963 176.7476,252.1613 176.7786,252.1233 C176.8196,252.0753 176.8576,252.0223 176.8926,251.9653 C176.9126,251.9323 176.9316,251.8993 176.9496,251.8633 C176.9846,251.7943 177.0166,251.7193 177.0436,251.6423 C177.0566,251.6043 177.0676,251.5653 177.0786,251.5253 C177.0996,251.4473 177.1166,251.3673 177.1296,251.2833 C177.1346,251.2433 177.1406,251.2023 177.1446,251.1603 C177.1516,251.0803 177.1556,250.9973 177.1556,250.9133",
    id: "Stroke-596",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9065,248.4169 C177.9385,248.4039 177.9725,248.3959 178.0075,248.3929 C178.0435,248.3889 178.0805,248.3899 178.1175,248.3949 C178.1525,248.3989 178.1855,248.4069 178.2185,248.4179 C178.2535,248.4299 178.2875,248.4449 178.3195,248.4629 C178.3505,248.4789 178.3805,248.4979 178.4085,248.5189 C178.4385,248.5399 178.4665,248.5629 178.4935,248.5879 C178.5195,248.6109 178.5445,248.6369 178.5675,248.6629 C178.5735,248.6699 178.5785,248.6759 178.5845,248.6829 C178.5915,248.6899 178.5965,248.6969 178.6025,248.7039 C178.6145,248.7179 178.6255,248.7319 178.6355,248.7479 C178.6565,248.7749 178.6765,248.8049 178.6955,248.8349 C178.7145,248.8659 178.7325,248.8969 178.7495,248.9299 C178.7815,248.9929 178.8095,249.0599 178.8325,249.1269 C178.8555,249.1949 178.8735,249.2649 178.8855,249.3349 C178.8925,249.3709 178.8975,249.4069 178.9005,249.4439 C178.9035,249.4789 178.9055,249.5139 178.9055,249.5479",
    id: "Stroke-598",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.7292,248.2031 C174.7032,248.2141 174.6782,248.2241 174.6532,248.2361 C174.6222,248.2511 174.5902,248.2681 174.5602,248.2861 C174.4992,248.3231 174.4412,248.3671 174.3882,248.4171 C174.3532,248.4501 174.3192,248.4841 174.2882,248.5221 C174.2882,248.5221 174.2882,248.5221 174.2872,248.5231",
    id: "Stroke-600",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.2873,248.5234 C174.2413,248.5784 174.1943,248.6334 174.1473,248.6894",
    id: "Stroke-602",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1477,248.6894 C174.1437,248.6944 174.1397,248.6994 174.1347,248.7054 C174.1147,248.7294 174.0957,248.7544 174.0777,248.7814 C174.0647,248.7994 174.0527,248.8194 174.0407,248.8384 C173.9827,248.9314 173.9347,249.0344 173.8967,249.1464 C173.8627,249.2484 173.8357,249.3564 173.8177,249.4694 C173.7987,249.5874 173.7897,249.7114 173.7897,249.8384",
    id: "Stroke-604",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.053,248.0546 C178.02,248.0676 177.989,248.0826 177.959,248.1016 C177.925,248.1216 177.892,248.1466 177.863,248.1736 C177.841,248.1946 177.82,248.2176 177.8,248.2416 C177.788,248.2556 177.777,248.2706 177.766,248.2856 C177.76,248.2966 177.752,248.3076 177.745,248.3196 C177.712,248.3716 177.684,248.4316 177.662,248.4956 C177.66,248.5006 177.659,248.5056 177.657,248.5106",
    id: "Stroke-606",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.3752,249.5126 C179.3752,249.4446 179.3702,249.3736 179.3612,249.3036 C179.3512,249.2286 179.3352,249.1536 179.3152,249.0786 C179.2942,249.0006 179.2682,248.9236 179.2362,248.8486 C179.2042,248.7726 179.1672,248.6996 179.1252,248.6286 C179.0982,248.5816 179.0682,248.5366 179.0372,248.4936 C179.0072,248.4536 178.9772,248.4156 178.9452,248.3796 C178.9102,248.3396 178.8732,248.3026 178.8342,248.2686 C178.7842,248.2236 178.7302,248.1826 178.6762,248.1486 C178.6232,248.1156 178.5672,248.0866 178.5122,248.0666 C178.4852,248.0556 178.4582,248.0466 178.4312,248.0396 C178.4132,248.0356 178.3952,248.0316 178.3762,248.0286 C178.3672,248.0266 178.3572,248.0256 178.3482,248.0236 C178.3302,248.0216 178.3122,248.0196 178.2942,248.0186 C178.2832,248.0176 178.2732,248.0176 178.2632,248.0176 C178.2342,248.0176 178.2052,248.0196 178.1772,248.0236 C178.1342,248.0296 178.0932,248.0396 178.0532,248.0546",
    id: "Stroke-608",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.905,249.5478 C178.905,249.6108 178.9,249.6738 178.888,249.7348 C178.877,249.7968 178.859,249.8588 178.833,249.9148 C178.806,249.9718 178.773,250.0258 178.729,250.0708 C178.685,250.1158 178.633,250.1518 178.573,250.1748",
    id: "Stroke-610",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.6067,
    y1: 196.1005,
    x2: 171.4027,
    y2: 193.9285,
    id: "Stroke-612",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.0442,
    y1: 199.8242,
    x2: 164.3362,
    y2: 197.5182,
    id: "Stroke-614",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.5701,
    y1: 198.3422,
    x2: 171.2251,
    y2: 203.1252,
    id: "Stroke-616",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.1296,
    y1: 190.5034,
    x2: 164.3706,
    y2: 195.2904,
    id: "Stroke-618",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.4836,196.0395 L164.4626,195.2575 C164.3776,195.2575 164.3076,195.3275 164.3076,195.4135 L164.3076,197.4335 C164.3076,197.5185 164.3776,197.5885 164.4626,197.5885 L166.4836,198.3715 C166.5696,198.3715 166.6386,198.3015 166.6386,198.2155 L166.6386,196.1955 C166.6386,196.1095 166.5696,196.0395 166.4836,196.0395 Z",
    id: "Stroke-620",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.0793,288.0732 C356.0523,288.0842 356.0233,288.0942 355.9953,288.1032 C355.9663,288.1132 355.9353,288.1222 355.9053,288.1312 C355.8733,288.1402 355.8413,288.1492 355.8083,288.1572 L355.7063,288.1802 C355.6443,288.1932 355.5823,288.2042 355.5203,288.2142 C355.4553,288.2232 355.3893,288.2322 355.3223,288.2382 C355.0673,288.2632 354.8023,288.2662 354.5473,288.2452 C354.4803,288.2402 354.4143,288.2332 354.3483,288.2242 C354.3323,288.2222 354.3163,288.2192 354.3013,288.2182 C354.2933,288.2172 354.2853,288.2162 354.2763,288.2152 C354.2693,288.2132 354.2623,288.2122 354.2543,288.2112 C354.2243,288.2062 354.1923,288.2002 354.1623,288.1952 C354.0973,288.1822 354.0323,288.1692 353.9683,288.1522 C353.9073,288.1362 353.8463,288.1192 353.7863,288.0982 C353.7523,288.0882 353.7193,288.0752 353.6853,288.0622 C353.6543,288.0502 353.6243,288.0362 353.5933,288.0222 C353.5653,288.0092 353.5373,287.9942 353.5103,287.9792 C353.4843,287.9652 353.4603,287.9502 353.4363,287.9332 C353.4193,287.9222 353.4023,287.9092 353.3863,287.8962 C353.3713,287.8852 353.3563,287.8722 353.3433,287.8582 C353.3303,287.8462 353.3183,287.8342 353.3073,287.8202 C353.2963,287.8072 353.2863,287.7952 353.2763,287.7812 C353.2683,287.7682 353.2613,287.7562 353.2543,287.7422 C353.2483,287.7292 353.2423,287.7162 353.2383,287.7022 C353.2293,287.6772 353.2253,287.6512 353.2253,287.6252",
    id: "Stroke-622",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.1701,
    y1: 285.3828,
    x2: 356.0791,
    y2: 288.0728,
    id: "Stroke-624",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.7326,
    y1: 328.7949,
    x2: 256.7326,
    y2: 331.1459,
    id: "Stroke-626",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.6047,
    y1: 312.8085,
    x2: 257.9157,
    y2: 329.2435,
    id: "Stroke-628",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.1262,
    y1: 313.0068,
    x2: 215.1262,
    y2: 315.1598,
    id: "Stroke-630",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.1262,
    y1: 314.2978,
    x2: 215.1262,
    y2: 314.2978,
    id: "Stroke-632",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.8303,
    y1: 284.4062,
    x2: 353.7383,
    y2: 287.0972,
    id: "Stroke-634",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.6604,284.8984 C363.6604,284.8854 363.6594,284.8734 363.6584,284.8594 C363.6564,284.8454 363.6534,284.8324 363.6494,284.8184 C363.6474,284.8104 363.6454,284.8034 363.6424,284.7964 C363.6394,284.7884 363.6374,284.7814 363.6344,284.7734 C363.6294,284.7624 363.6244,284.7524 363.6184,284.7424 C363.6134,284.7334 363.6084,284.7254 363.6034,284.7174 C363.5984,284.7104 363.5944,284.7034 363.5894,284.6964 C363.5824,284.6874 363.5764,284.6794 363.5694,284.6714 C363.5624,284.6644 363.5564,284.6564 363.5504,284.6494 C363.5454,284.6444 363.5404,284.6384 363.5354,284.6344 C363.5254,284.6254 363.5154,284.6164 363.5064,284.6064 C363.5024,284.6044 363.4994,284.6014 363.4954,284.5984 C363.4794,284.5854 363.4624,284.5714 363.4434,284.5574 C363.4304,284.5484 363.4164,284.5394 363.4024,284.5304 C363.3844,284.5184 363.3644,284.5064 363.3444,284.4964 C363.3194,284.4824 363.2944,284.4694 363.2674,284.4574 C363.2294,284.4394 363.1894,284.4214 363.1474,284.4064 C363.1004,284.3884 363.0504,284.3714 362.9984,284.3554 C362.9714,284.3474 362.9434,284.3394 362.9154,284.3334 C362.8824,284.3244 362.8484,284.3164 362.8134,284.3084 C362.7574,284.2954 362.6974,284.2844 362.6374,284.2744 C362.5364,284.2574 362.4314,284.2454 362.3234,284.2364 C362.2134,284.2274 362.1004,284.2234 361.9884,284.2234 C361.8764,284.2234 361.7644,284.2274 361.6544,284.2364 C361.5474,284.2454 361.4414,284.2574 361.3404,284.2744 C361.2794,284.2844 361.2214,284.2954 361.1634,284.3084 C361.1294,284.3164 361.0954,284.3244 361.0624,284.3334 C361.0344,284.3394 361.0074,284.3474 360.9794,284.3554 C360.9274,284.3714 360.8774,284.3884 360.8304,284.4064",
    id: "Stroke-636",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.7385,287.0976 C353.6965,287.1136 353.6565,287.1296 353.6185,287.1476 C353.5925,287.1596 353.5665,287.1736 353.5425,287.1866 C353.5215,287.1986 353.5025,287.2096 353.4835,287.2216 C353.4695,287.2306 353.4555,287.2396 353.4425,287.2486 C353.4245,287.2616 353.4065,287.2756 353.3895,287.2886 C353.3865,287.2916 353.3845,287.2946 353.3805,287.2976 C353.3705,287.3066 353.3605,287.3166 353.3505,287.3256 C353.3455,287.3296 353.3415,287.3346 353.3365,287.3406 C353.3295,287.3476 353.3225,287.3556 353.3165,287.3626 C353.3095,287.3696 353.3035,287.3786 353.2975,287.3866 C353.2925,287.3946 353.2875,287.4016 353.2825,287.4086 C353.2775,287.4166 353.2725,287.4246 353.2675,287.4326 C353.2615,287.4436 353.2575,287.4536 353.2525,287.4646 C353.2495,287.4716 353.2465,287.4796 353.2435,287.4876 C353.2405,287.4946 353.2385,287.5016 353.2365,287.5096 C353.2325,287.5226 353.2295,287.5366 353.2275,287.5506 C353.2265,287.5636 353.2255,287.5766 353.2255,287.5896",
    id: "Stroke-638",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.6604,284.9345 C363.6604,284.9635 363.6544,284.9925 363.6444,285.0205 C363.6394,285.0335 363.6344,285.0455 363.6284,285.0585 C363.6204,285.0725 363.6124,285.0845 363.6034,285.0975 C363.5704,285.1455 363.5264,285.1865 363.4804,285.2205 C363.4334,285.2545 363.3834,285.2865 363.3314,285.3125 C363.2794,285.3385 363.2244,285.3625 363.1704,285.3825",
    id: "Stroke-640",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.4226,
    y1: 312.3603,
    x2: 213.4226,
    y2: 314.7113,
    id: "Stroke-642",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.6047,
    y1: 312.8085,
    x2: 213.4227,
    y2: 312.3605,
    id: "Stroke-644",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.7326,
    y1: 331.1455,
    x2: 257.9156,
    y2: 331.5935,
    id: "Stroke-646",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.4226,
    y1: 310.0097,
    x2: 213.4226,
    y2: 312.3607,
    id: "Stroke-648",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.4934,315.497 C215.4524,315.481 215.4114,315.463 215.3724,315.443 C215.3344,315.424 215.2954,315.401 215.2614,315.375 C215.2264,315.35 215.1934,315.318 215.1684,315.282 C215.1614,315.273 215.1554,315.264 215.1504,315.254 C215.1454,315.244 215.1404,315.234 215.1374,315.225 C215.1304,315.203 215.1264,315.183 215.1264,315.16",
    id: "Stroke-650",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.4495,
    y1: 314.0468,
    x2: 9.0005,
    y2: 271.7568,
    id: "Stroke-652",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.4495,
    y1: 320.4228,
    x2: 3.6965,
    y2: 276.1198,
    id: "Stroke-654",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4426,
    y1: 268.0253,
    x2: 11.4426,
    y2: 271.5053,
    id: "Stroke-656",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.405,
    y1: 272.3906,
    x2: 120.449,
    y2: 313.3886,
    id: "Stroke-658",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.9861,
    y1: 246.0185,
    x2: 105.8461,
    y2: 277.4595,
    id: "Stroke-660",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.0007,
    y1: 271.7568,
    x2: 11.4427,
    y2: 270.8298,
    id: "Stroke-662",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.9231,
    y1: 305.4345,
    x2: 1.7731,
    y2: 305.4915,
    id: "Stroke-664",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.7732,
    y1: 305.4912,
    x2: 1.7732,
    y2: 273.0402,
    id: "Stroke-666",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.7732,
    y1: 273.04,
    x2: 11.4422,
    y2: 269.371,
    id: "Stroke-668",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.0002,
    y1: 272.3671,
    x2: 1.7732,
    y2: 273.0401,
    id: "Stroke-670",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.9231,
    y1: 273.0966,
    x2: 3.6961,
    y2: 273.7696,
    id: "Stroke-672",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.0007,
    y1: 271.7568,
    x2: 3.6957,
    y2: 273.7698,
    id: "Stroke-674",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.2278,
    y1: 304.8935,
    x2: 7.2278,
    y2: 277.4595,
    id: "Stroke-676",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.405,272.3906 C12.298,272.3496 12.191,272.3036 12.089,272.2506 C11.988,272.1996 11.887,272.1396 11.796,272.0706 C11.705,272.0016 11.618,271.9206 11.552,271.8276 C11.535,271.8026 11.52,271.7776 11.506,271.7506 C11.493,271.7266 11.482,271.7016 11.473,271.6746 C11.463,271.6476 11.455,271.6196 11.45,271.5896 C11.445,271.5626 11.443,271.5346 11.443,271.5056",
    id: "Stroke-678",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-680",
    strokeWidth: 2,
    points: "421.0979 231.206 465.5899 248.089 465.5899 250.439 465.5899 252.79 465.4959 253.059 465.4959 255.41 465.4959 257.76 464.9389 257.973 464.9389 331.187 463.1419 331.869 461.3449 332.551 461.0659 332.444 261.4419 408.193 261.4499 408.176 259.6529 408.857 257.8559 409.539 257.8479 409.769 120.4499 357.632 120.4499 284.417 119.8909 284.205 119.8909 281.854 119.8909 279.504 120.4489 279.504 120.4489 78.582 122.2449 77.9 122.2449 77.864 325.7429 0.645 325.7909 0.664 327.5389 0 420.4469 35.254 420.4469 231.453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.449,200.2558 L13.601,240.7998 C13.218,240.9448 12.865,241.1598 12.558,241.4328 C12.457,241.5228 12.362,241.6188 12.272,241.7218 C12.137,241.8738 12.018,242.0378 11.913,242.2118 C11.615,242.7118 11.452,243.2798 11.443,243.8598 C11.443,243.8778 11.443,243.8958 11.443,243.9138 L11.443,268.0258 L5.68434189e-14,272.3668 L5.68434189e-14,304.8188 L1.773,305.4908 L1.923,305.5608 L3.696,306.2338 L7.228,304.8938 L120.449,347.8568",
    id: "Stroke-682",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketStudioPlus);
export default __webpack_public_path__ + "static/media/pocket_studio_plus.9887f1297b51366d0c30ef741c27a2f0.svg";
export { ForwardRef as ReactComponent };